<script>
import { formatDate, DateUtil } from '@/utils/date.js'
import dialog from '@/components/Dialog'
import CalendarInput from '@/components/CalendarInput'
import StationInfoComponent from '@/components/StationInfoComponent'
import PassPointInfoComponent from '@/components/PassPointInfoComponent'
import ShiftAddComponent from '@/components/ShiftAddComponent'
import RouteInfoWindow from '@/components/RouteInfoWindow'
import ShiftDetailEventWindowMask from '@/components/ShiftDetailEventWindowMask'
import { StringUtil } from '@/utils/StringUtil.js'
// import $ from 'jquery'
export default {
  components: {
    // dialog 弹出框组件
    'v-dialog': dialog,
    // 日历组件
    CalendarInput,
    StationInfoComponent,
    PassPointInfoComponent,
    RouteInfoWindow,
    ShiftDetailEventWindowMask,
    ShiftAddComponent
  },
  data () {
    return {
      // event项目 option
      option: {
        imgs: null,
        file: null,
        chooseImageFlag: false
      },
      // event项目 shiftEvent
      shiftEvent: {
        createTime: null,
        createUser: '',
        eventDate: '',
        eventId: '',
        eventName: '',
        eventNote: '',
        eventPhotoUrl: '',
        updateTime: null,
        updateUser: ''
      },
      // 月 checkbox
      mondayCheckbox: false,
      // 火 checkbox
      tuesdayCheckbox: false,
      // 水 checkbox
      wednesdayCheckbox: false,
      // 木 checkbox
      thursdayCheckbox: false,
      // 金 checkbox
      fridayCheckbox: false,
      // 土 checkbox
      saturdayCheckbox: false,
      // 日 checkbox
      sundayCheckbox: false,
      // message提示弹出框配置信息
      showDialog: false,
      dialogOption: {
        showNo: false,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      shiftTimeInfoList: [],
      shiftTimeInfoListByDriverUid: [],
      // 运行开始日对应的周几
      weekNumber: 0,
      // 循环入力便日期集合
      loopDateList: [],
      // 適用间隔
      weekIntervalNum: null,
      // 適用開始日
      startTime: '',
      // 適用終了日
      endTime: '',
      // 便経由地情報集合
      shiftPasspoint: [],
      // 选择的时的集合
      hourList: [],
      // 选择的分的集合
      minuteList: [],
      // 拼接的时间的集合
      timeList: [],
      // user情报
      userInfo: [],
      // driver情报
      driverInfo: [],
      // session中取得的车辆情报
      // vehicleInfoList: [],
      // 过滤后的车辆情报
      vehicleInfo: [],
      // 地区情报
      areaInfo: [],
      // 选择的车辆信息
      selectedVehicle: null,
      // route和停留所信息
      routeStationInfo: [],
      // 被选中的route相关的所有信息
      selectedRouteStationInfo: [],
      test: [],
      // route信息
      routeInfo: [],
      // route被选择标志位
      routeSelected: false,
      // 选择的diver信息
      selectedDriver: {},
      loopUseCheckbox: false,
      // driver校验message
      driverMessage: 'ドライバーは別の便に運転予定があります。',
      driverMessage2: '同じドライバーが複数の便で選択されています。',
      // 车辆校验message
      vehicleMessage: '車両はブロックされています。再度選択してください。',
      vehicleMessage2: '同じ車両が複数の便で選択されています。',
      vehicleMessage3: 'ドライバーと車両の交通事業者が異なります。',
      // 停留所时间校验message
      stationTimeMessage: '停留所の到着予定時間を入力してください。',

      // 预约者情报数组
      shiftReservationInfos: [],
      hrefFlag: false,
      startYear: new Date().getFullYear(),
      startMonth: new Date().getMonth() + 1,
      startDay: new Date().getDate(),
      endYear: new Date().getFullYear(),
      endMonth: new Date().getMonth() + 1,
      endDay: new Date().getDate(),

      // frontId管理用
      ShiftFrontIdCount: 1,
      // 接続リスト
      connectList: [{
        shiftId: '',
        connectSourceShiftId: '',
        stationId: '',
        connectSourceStationId: '',
        stationUseTime: '',
        shiftIndex: 0,
        connectSourceShiftIndex: 0,
      }],
      // 接続情報グループリスト
      connectGroupList: [],
      // 便エラーリスト
      shiftErrorList: [],
      // 接続エラーリスト
      connectErrorList: [],
      // 使われていない便リスト
      notUseShiftList: [],
      connectTimeError: false,
      connectGroupHtml: '',
      // 削除予定便リスト
      removeShiftList: [],
      // 区域内便判定用 便ID
      parentShiftId: '0000',
    }
  },
  props: {
    // ShiftLogin传过来的title和btnName参数
    title: { type: String, default: '' },
    btnName: { type: String, default: '' },
    // 不同功能的标志位 0:便を登録 1:便を編集 2：このルートで便を登録 3:便を登録(増便)
    functionFlag: {type: String, default: '0'},
    // 便情報
    shiftBasicModel: {},
    // 運行日：年
    moveShiftTimeYear: {type: Number, default: new Date().getFullYear()},
    // 運行日：月
    moveShiftTimeMonth: { type: Number, default: new Date().getMonth() + 1 },
    // 運行日：日
    moveShiftTimeDay: {type: Number, default: new Date().getDate()},
    // 区域外対応
    shiftList: {},
    shiftConnectList: {},
    isLoading: true,
    lockedByReserve: false,
    lockedByAddShift: false
  },
  created () {
    this.$axios.get('shift/selectInfoName').then(response => {
      // 获取user信息
      this.userInfo = response.data.userInfo
      this.userInfo.forEach(item => {
        if (!StringUtil.isEmpty(item.roleFlag) &&
      (item.roleFlag.substring(1, 2) === '1' || item.roleFlag.substring(4, 5) === '1')) {
          this.driverInfo.push(item)
        }
      })
      this.driverInfo.sort((x, y) => {
        return (x.lastNamekana + x.firstNamekana).localeCompare(
          y.lastNamekana + y.firstNamekana
        )
      })
    })
    this.$axios.get('shift/selectVehicleInfo').then(response => {
      // 获取车辆信息
      // this.vehicleInfoList = response.data.vehicleInfo
      this.vehicleInfo = response.data.vehicleInfo
      // this.getVehicleInfo(new Date())
    })
    this.$axios.get('shift/selectAreaInfo').then(response => {
      // 获取地区信息
      this.areaInfo = response.data.areaInfo
    })
    if (this.$route.query.isCancel === 'true' || this.$route.query.isCancel === true) {
      if (this.shiftBasicModel.routeId !== '') {
        this.routeSelected = true
      }
      // 获取循环入力 信息
      if (sessionStorage.getItem('loopData') !== null) {
        let loopData = JSON.parse(sessionStorage.getItem('loopData'))
        this.loopUseCheckbox = loopData.loopUseCheckbox
        this.mondayCheckbox = loopData.mondayCheckbox
        this.tuesdayCheckbox = loopData.tuesdayCheckbox
        this.wednesdayCheckbox = loopData.wednesdayCheckbox
        this.thursdayCheckbox = loopData.thursdayCheckbox
        this.fridayCheckbox = loopData.fridayCheckbox
        this.saturdayCheckbox = loopData.saturdayCheckbox
        this.sundayCheckbox = loopData.sundayCheckbox
        this.startTime = DateUtil.shortStringToDate(loopData.startTime)
        this.endTime = DateUtil.shortStringToDate(loopData.endTime)
        this.startYear = DateUtil.getYear(loopData.startTime)
        this.startMonth = DateUtil.getMonth(loopData.startTime)
        this.startDay = DateUtil.getDay(loopData.startTime)
        this.endYear = DateUtil.getYear(loopData.endTime)
        this.endMonth = DateUtil.getMonth(loopData.endTime)
        this.endDay = DateUtil.getDay(loopData.endTime)
        this.weekIntervalNum = loopData.weekIntervalNum
      }
    }
  },
  async mounted () {
    // if (this.functionFlag !== '2') {
      // 全ルート情報を取得 接続便対応のため、functionFlag == '2'（このルートで便を登録）のときも実行する
      // 获取route下拉框和停留所相关信息
      this.routeStationInfo = JSON.parse(sessionStorage.getItem('routeStationInfo'))
      // 将从后台取出的数据进行过滤
      this.routeInfo = this.unique(this.routeStationInfo)
    // }
    // 为便を編集画面初始化ルート、ドライバー,并记录传入的routeId
    if (this.functionFlag === '3') {

    } else if (this.functionFlag === '2') {
      // このルートで便を登録获取route信息
      let selectedRouteStationInfo = JSON.parse(sessionStorage.getItem('routerInfo'))
      // 选择的route Id赋值
      // this.shiftBasicModel.routeId = selectedRouteStationInfo[0].routeId
      this.shiftList[0].shiftBasic.routeId = selectedRouteStationInfo[0].routeId
    }
    // 新しい便のときは、区域ごとのデフォルト便料金を取得
    if(this.functionFlag === '0' || this.functionFlag === '2'){
      this.$axios.get('shift/getShiftStandardCost').then(response => {
        this.shiftList[0].shiftBasic.shiftCost = response.data.shiftStandardCost
      })
    }
  },
  watch: {
    isLoading: function(){
      console.log("loaded")
      let stationComCount = 0
      if (this.functionFlag === '1' || this.functionFlag === '3') {
        for(let i = 0; i < this.shiftList.length; i++){
          this.chooseRoute(this.shiftList[i].shiftBasic.routeId, i)
          this.chooseDriver(this.shiftList[i].shiftBasic.driverUid, i)
          this.chooseVehicle(this.shiftList[i])
          this.chooseArea(this.shiftList[i].shiftBasic.areaId, i)
          // 区域内便判定
          if(this.shiftList[i].shiftBasic.transportKind == 0){
            this.parentShiftId = this.shiftList[i].shiftBasic.shiftId
          }
          if(this.shiftList[i].functionFlag == 1){
            this.$refs.passpointCom[i].mountedFunc()
          }else{
            this.$refs.stationCom[stationComCount].mountedFunc()
            stationComCount++
          }
        }
        this.setShiftConnect()
        this.chooseConnect()
      }
    }
  },
  methods: {
    // 显示地图窗口
    async showWIndow () {
      if (this.hrefFlag) {
        await this.$refs.routeInfoWindow.initGoogleMap()
        // 終わったらフラグを戻す
        this.hrefFlag = false
      }
    },
    // 选择route
    async chooseRoute (val, index='no', show=false) {
      console.log("methods: chooseRoute")
      console.log("val = " + val+ " index = " + index)
      // this.routeSelected = true
      this.hrefFlag = false
      if(val == '' || val == null){
        this.hrefFlag = false
      }else{
        this.hrefFlag = true
      }
      let routeInfo = {}
      const { data } = await this.$axios.get('route/getRouteInfoList')
      const { data: datas } = await this.$axios.get('route/getAllStationData')
      let stationDataList = datas.stationDataList
      for (const i of data.routeInfoList) {
        if (i.routeId === val) {
          routeInfo = i
          this.shiftList[index].shiftBasic.routeName = i.routeName
        }
      }
      // 清空路信息
      let routerList = []
      let pointList = []
      for (let i of routeInfo.routePassPointList) {
        for (let s of stationDataList) {
          if (i.stationId === s.stationId) {
            routerList.push({
              font: i.routeNo,
              name: s.addressName,
              address: s.stationName,
              stationLat: s.stationLat,
              stationLng: s.stationLng,
              officeFlag: s.officeFlag
            })
            // 路线规划
            pointList.push({
              lng: s.stationLng,
              lat: s.stationLat
            })
          }
        }
      }

      // 運行区分・ドライバーアプリ更新
      if(index != 'no'){
        this.shiftList[index].routeSelected = true
        this.shiftList[index].shiftBasic.transportKind = routeInfo.transportKind
        this.shiftList[index].routeType = routeInfo.routeType
      }
      this.$store.commit('SET_ROUTERLIST', { routerList: routerList, pointList: pointList })
      if(show == true && this.hrefFlag && val != ''){
        this.showWIndow()
      }
      
      //接続エリア更新
      this.setShiftConnectStationList()
    },
    // 从停留所组件中传入选择的hour集合
    getHourList (selectValue, index) {
      this.shiftList[index].hourList = selectValue
      console.log("getHourList" + index)
      this.hourList = selectValue

      // 接続更新
      if(this.shiftList.length > 1){
        this.setShiftConnectStationList()
        this.chooseConnect()
        this.shiftConnectList.splice(0,this.shiftConnectList)
      }
    },
    // 从停留所组件中传入选择的minute集合
    getMinuteList (selectValue, index) {
      this.shiftList[index].minuteList = selectValue
      this.minuteList = selectValue

      // 接続更新
      if(this.shiftList.length > 1){
        this.setShiftConnectStationList()
        this.chooseConnect()
        this.shiftConnectList.splice(0,this.shiftConnectList)
      }
    },
    // 从停留所组件中传入选择的station集合
    getSelectedRouteStationInfoList (selectValue, index) {
      console.log("getSelectedRouteStationInfoList")
      this.shiftList[index].stationList = selectValue
      this.shiftList[index].shiftBasic.routeName = selectValue[0].routeName
    },
    // 根据对象数组中的某个属性去重
    unique (arr) {
      const res = new Map()
      return arr.filter((a) => !res.has(a.routeId) && res.set(a.routeId, 1))
    },
    // 適用間隔去0处理
    removeZero (value) {
      this.weekIntervalNum = value.replace(/\b(0+)/gi, '')
    },
    // 选择地区
    chooseArea (val, index) {
      if (val === '') {
        this.shiftList[index].shiftBasic.areaId = null
        this.shiftList[index].shiftBasic.areaName = ''
      } else {
        for (let i = 0; i < this.areaInfo.length; i++) {
          if (this.areaInfo[i].codeValue === val) {
          // 记录选择的地区名
            this.shiftList[index].shiftBasic.areaName = this.areaInfo[i].codeName
            break
          }
        }
      }
    },
    // 选择driver
    chooseDriver (val, index) {
      console.log("chooseDriver")
      console.log("val:" + val + " index:" + index)
      for (let i = 0; i < this.driverInfo.length; i++) {
        if (this.driverInfo[i].uid === val) {
          // 记录选择的driver名
          this.shiftList[index].shiftBasic.driverName = this.driverInfo[i].lastName + ' ' + this.driverInfo[i].firstName
          // 记录选择的dirver假名
          this.shiftList[index].shiftBasic.driverKanaName = this.driverInfo[i].lastNamekana + ' ' + this.driverInfo[i].firstNamekana
          // 事業者IDをセット
          if(this.shiftList[index].shiftBasic.transportKind == 1){
            this.shiftList[index].shiftBasic.driverTransportId = this.driverInfo[i].transportId
          }
          break
        }
      }

      // if(index===0){
        if(val != null && val != ''){
          this.$axios.get('shift/selectShiftTimeInfoListByDriverUid',
            {params: {driverUid: val, moveShiftTime: this.shiftList[0].shiftBasic.moveShiftTime}})
            .then(response => {
              this.shiftList[index].shiftTimeInfoListByDriverUid = response.data.shiftTimeInfoListByDriverUid
            })
          .catch(function (error) {
          console.log(error)
          return
        })
        }
      // }
    },
    // 选择车辆
    chooseVehicle (item) {
      console.log("chooseVehicle")
      // 选择的车辆不为空
      if (!StringUtil.isEmpty(item.shiftBasic.vehicleId)) {
        for (let i = 0; i < this.vehicleInfo.length; i++) {
          if (this.vehicleInfo[i].vehicleId === item.shiftBasic.vehicleId) {
          // 记录选择的车辆名
            item.shiftBasic.vehicleName = this.vehicleInfo[i].vehicleName
            // 记录选择的车辆的定员数
            item.shiftBasic.passengerNumber = this.vehicleInfo[i].passengerNumber
            // 表示用車両IDをセット
            item.shiftBasic.displayVehicleId = this.vehicleInfo[i].displayVehicleId
            // 事業者IDをセット
            if(item.shiftBasic.transportKind == 1){
              item.shiftBasic.vehicleTransportId = this.vehicleInfo[i].transportId
            }
            break
          }
        }
        this.$axios.get('shift/selectShiftTimeInfoList',
          {params: {vehicleId: item.shiftBasic.vehicleId, moveShiftTime: this.shiftList[0].shiftBasic.moveShiftTime}})
          .then(response => {
            this.shiftTimeInfoList = response.data.shiftTimeInfoList
            item.shiftTimeInfoList = response.data.shiftTimeInfoList
          })
          // 编辑画面，如果所选车辆定员数小于乘客总人数，则显示提示框
        if (this.functionFlag === '1') {
          if (item.reserveNumber > item.passengerNumber) {
            // 车辆选择不正确的场合，将其置为空
            item.shiftBasic.vehicleId = ''
            this.showMessage('車両の定員数は予約者数より少ないため、車両変更できません。')
          }
        }
      }
    },
    setShiftConnectStationList(type = 0){
      console.log("setShiftConnectStationList")
      // 停留所接続制限設定
      for(let i = 0; i < this.shiftList.length; i++){
        if(this.shiftList[0].shiftBasic.shiftFlag == '0'){
          // 行きの場合、接続先停留所に最後の停留所を選択することはできない
          this.shiftList[i].stationList[0].canStart = true
          this.shiftList[i].stationList[this.shiftList[i].stationList.length - 1].canArrive = false
        }else{
          // 帰りの場合、接続元停留所に最初の停留所を選択することはできない
          this.shiftList[i].stationList[0].canStart = false
          this.shiftList[i].stationList[this.shiftList[i].stationList.length - 1].canArrive = true
        }
      }

      if(this.functionFlag != '3'){
        // shiftConnectListに選んだ便のstationListをセット
        for(let shiftConnectIndex = 0; shiftConnectIndex < this.shiftConnectList.length; shiftConnectIndex++){
          for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
            let targetId
            if(this.shiftList[shiftIndex].functionFlag != '1'){
              // 新規の便なら
              targetId = this.shiftList[shiftIndex].frontId
            }else{
              // 既存の便なら
              targetId = this.shiftList[shiftIndex].shiftBasic.shiftId
            }
            // 停留所一覧の大本は便一覧画面でセッションに入れたものを使っている
            if(type === 0 || type === 1){
              if(this.shiftConnectList[shiftConnectIndex].frontShiftConnect.connectSourceShiftId == targetId){
                this.shiftConnectList[shiftConnectIndex].frontShiftConnect.connectSourceStationList = this.shiftList[shiftIndex].stationList
              }
            }
            if((type === 0) || type === 2){
              if(this.shiftConnectList[shiftConnectIndex].frontShiftConnect.shiftId == targetId){
                this.shiftConnectList[shiftConnectIndex].frontShiftConnect.stationList = this.shiftList[shiftIndex].stationList
              }
            }
          }
        }
      }
    },
    chooseConnect() {
      console.log("chooseConnect")
      // 時刻をクリア
      for(let i = 0; i < this.shiftConnectList.length; i++){
        this.shiftConnectList[i].frontShiftConnect.connectSourceStationTime = ''
        this.shiftConnectList[i].frontShiftConnect.stationTime = ''
      }

      // 停留所の時刻を取得
      if (this.stationTimeValidate()) {
        if (this.functionFlag == '1'){
          if (this.editorTimeCombination()) {
            console.log("chooseConnect after editorTimeCombination")

            for(let i = 0; i < this.shiftConnectList.length; i++){
              for(let j = 0; j < this.shiftList.length; j++){
                let targetId
                if(this.shiftList[j].functionFlag != '1'){
                  // 新規の便なら
                  targetId = this.shiftList[j].frontId
                }else{
                  // 既存の便なら
                  targetId = this.shiftList[j].shiftBasic.shiftId
                }
                if(this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId ==targetId){
                  for(let k = 0; k < this.shiftList[j].stationList.length; k++){
                    if(this.shiftList[j].stationList[k].stationId == this.shiftConnectList[i].frontShiftConnect.connectSourceStationId){
                      this.shiftConnectList[i].frontShiftConnect.connectSourceStationTime = this.shiftList[j].timeList[k]
                    }
                  }
                }
                if(this.shiftConnectList[i].frontShiftConnect.shiftId ==targetId){
                  for(let k = 0; k < this.shiftList[j].stationList.length; k++){
                    if(this.shiftList[j].stationList[k].stationId == this.shiftConnectList[i].frontShiftConnect.stationId){
                      this.shiftConnectList[i].frontShiftConnect.stationTime = this.shiftList[j].timeList[k]
                    }
                  }
                }
              }
            }
          }
        }else{
          if (this.timeCombination()) {
            console.log("chooseConnect after timeCombination")
            for(let i = 0; i < this.shiftConnectList.length; i++){
              for(let j = 0; j < this.shiftList.length; j++){
                if(this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId == this.shiftList[j].frontId){
                  for(let k = 0; k < this.shiftList[j].stationList.length; k++){
                    if(this.shiftList[j].stationList[k].stationId == this.shiftConnectList[i].frontShiftConnect.connectSourceStationId){
                      this.shiftConnectList[i].frontShiftConnect.connectSourceStationTime = this.shiftList[j].timeList[k]
                    }
                  }
                }
                if(this.shiftConnectList[i].frontShiftConnect.shiftId == this.shiftList[j].frontId){
                  for(let k = 0; k < this.shiftList[j].stationList.length; k++){
                    if(this.shiftList[j].stationList[k].stationId == this.shiftConnectList[i].frontShiftConnect.stationId){
                      this.shiftConnectList[i].frontShiftConnect.stationTime = this.shiftList[j].timeList[k]
                    }
                  }
                }
              }
            }
          }

        }
      }

      let duplicateFlag = false
      // バリデーション 接続エラーチェック
      for(let i = 0; i < this.shiftConnectList.length; i++){
        this.shiftConnectList[i].frontShiftConnect.errorMessage = ''
        
        // 同じ便同士の接続禁止
        if(this.shiftConnectList[i].frontShiftConnect.shiftId == this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId){
          this.shiftConnectList[i].frontShiftConnect.errorMessage = '同じ便同士で接続することはできません。'
        }

        // 同じ便の組み合わせは１度しか許可しない
        duplicateFlag = false
        for(let j=0; j < this.shiftConnectList.length; j++){
          if(i != j){
            if(this.shiftConnectList[i].frontShiftConnect.shiftId == this.shiftConnectList[j].frontShiftConnect.shiftId){
              if(this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId == this.shiftConnectList[j].frontShiftConnect.connectSourceShiftId){
                console.log("同じ便の組み合わせあり " + i + " " + j)
                duplicateFlag = true
              }
            }
          }
        }
        if(duplicateFlag == true){
          this.shiftConnectList[i].frontShiftConnect.errorMessage = '同じ便の組み合わせを２度以上使用することはできません。'
        }else{
          console.log("同じ組み合わせの便なし")
        }

        // 行き・帰りによる区域内便の使用制限
        // 行き
        if(this.shiftList[0].shiftBasic.shiftFlag == '0'){
          if(this.shiftConnectList[i].frontShiftConnect.shiftId == this.parentShiftId){
            this.shiftConnectList[i].frontShiftConnect.errorMessage = '行きの場合、接続先に区域内便を設定することはできません'
          }
        }
        else{
          // 帰り
          if(this.shiftConnectList[i].frontShiftConnect.shiftId == this.parentShiftId){
            this.shiftConnectList[i].frontShiftConnect.errorMessage = '帰りの場合、接続元に区域内便を設定することはできません'
          }
        }
      }
    },
    // 从日历子组件中传入运行日
    getMoveShiftTime (selectValue) {
      console.log("getMoveShiftTime")
      // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
      let selectDate = DateUtil.calendarToDate(selectValue)
      // 根据选择的运行日 给パターン設定赋值
      this.weekNumber = selectDate.getDay()
      // 将date格式转化为yyyyMMdd格式
      let forDate = formatDate(selectDate, 'yyyyMMdd')
      // this.shiftBasicModel.moveShiftTime = forDate
      this.shiftList[0].shiftBasic.moveShiftTime = forDate
      // this.getVehicleInfo(selectDate)
      for(let i = 0; i < this.shiftList.length; i++){
        this.chooseDriver(this.shiftList[i].shiftBasic.driverUid, i)
        this.chooseVehicle(this.shiftList[i])
      }
    },
    // 从日历子组件中传入適用開始日
    getStartTime (selectValue) {
      // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
      this.startTime = DateUtil.calendarToDate(selectValue)
    },
    // 从日历子组件中传入適用終了日
    getEndTime (selectValue) {
      // 将日历组件选择的时间yyyy年MM月dd日转化为日期Date格式
      this.endTime = DateUtil.calendarToDate(selectValue)
    },
    // 返回上一层
    goback () {
      // 从event作成返回便登录或便编辑的场合
      if (this.$route.query.isCancel === 'true' || this.$route.query.isCancel === true) {
        if (this.functionFlag === '0') {
          this.$router.push({ name: 'MovementShift' })
        }
      } else if (this.$route.query.editorIsCancel === 'true' || this.$route.query.editorIsCancel === true) {
        if (this.functionFlag === '1') {
          // this.$router.push({ path: '/ShiftWithEventDetail', query: {from: 'ShiftEditor'}})
          this.$router.push({path: '/ShiftWithEventDetail', query: {from: 'ShiftEditor', shiftId: this.shiftList[0].shiftBasic.shiftId}})
        }
      } else {
        this.$router.go(-1)
      }
    },
    // 选择的车辆被挂载到的便的时间的校验
    // 車両スケジュール重複チェック
    shiftVehiclValidate (shiftTimeInfoList) {
      console.log("shiftVehiclValidate")
      let errorCount = 0
      // 循环入力checkbox被勾上，则无需校验
      if (this.loopUseCheckbox) {
        return true
      }
      // 車両エラーをリセット
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        this.shiftList[shiftIndex].vehicleError = false
      }

      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        // 获取当前便的开始时间
        let currentShiftStartTime = this.shiftList[shiftIndex].timeList[0]
        // 获取当前便的结束时间
        let currentShiftEndTime = this.shiftList[shiftIndex].timeList[this.shiftList[shiftIndex].timeList.length - 1]
        for (let i = 0; i < this.shiftList[shiftIndex].shiftTimeInfoList.length; i++) {
          // 获取的时间根据sortNo进行排序
          this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
          // 获取车辆关联便的出发时间
          let startTime = this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime[0].startEstimateTime
          // 获取车辆关联便的到达时间
          let endTime = this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime[this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime.length - 1].arriveEstimateTime
          if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
            if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                  DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
              this.shiftList[shiftIndex].vehicleError = true
              errorCount++
            }
          }
        }
      }
      if(errorCount > 0){
        return false
      }else{
        return true
      }
    },
    // 选择的driver被挂载到的便的时间的校验
    shiftDriverValidate () {
      // ドライバー選択時に取得したドライバー情報を使って、そのドライバーが他の便の同じ時間に使われていないかチェックする（ダブルブッキング禁止）
      console.log("shiftDriverValidate")
      if (this.loopUseCheckbox) {
        return true
      }
      // ドライバーエラーをリセット
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        this.shiftList[shiftIndex].driverError = false
        this.shiftList[shiftIndex].driverError2 = false
      }
      
      let errorCount = 0
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        if(this.shiftList[shiftIndex].functionFlag != '1'){
          if (!StringUtil.isEmpty(this.shiftList[shiftIndex].shiftBasic.driverUid)) {
            // 获取当前便的开始时间
            let currentShiftStartTime = this.shiftList[shiftIndex].timeList[0]
            // 获取当前便的结束时间
            let currentShiftEndTime = this.shiftList[shiftIndex].timeList[this.shiftList[shiftIndex].timeList.length - 1]
            for (let i = 0; i < this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid.length; i++) {
              // 获取的时间根据sortNo进行排序
              this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
              // 获取driver关联便的出发时间
              let startTime = this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime[0].startEstimateTime
              // 获取driver关联便的到达时间
              let endTime = this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime[this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime.length - 1].arriveEstimateTime
              if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
                console.log("driverTimeCheck")
                console.log("target " + startTime + "～" + endTime)
                console.log("current " + currentShiftStartTime + "～" + currentShiftEndTime)
                if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                    DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
                  this.shiftList[shiftIndex].driverError = true
                  errorCount++
                }
              }
            }
          }
        }
        // ページ内でのドライバー二重使用をチェック
        if(this.shiftList[shiftIndex].shiftBasic.driverUid!=''&&this.shiftList[shiftIndex].shiftBasic.driverUid!=null){
          for(let shiftIndex2 = 0; shiftIndex2 < this.shiftList.length; shiftIndex2++){
            if(shiftIndex != shiftIndex2){
              if(this.shiftList[shiftIndex].shiftBasic.driverUid==this.shiftList[shiftIndex2].shiftBasic.driverUid){
                this.shiftList[shiftIndex].driverError2 = true
                this.shiftList[shiftIndex2].driverError2 = true
                errorCount++
              }
            }
          }
        }
      }
      if(errorCount > 0){
        return false
      }else{
        return true
      }
    },
    // 循环入力便选择的车辆被挂载到的便的时间的校验
    loopVehicleValidate (shiftTimeInfoList, startDate, endDate) {
      for (let i = 0; i < shiftTimeInfoList.length; i++) {
        // 获取的时间根据sortNo进行排序
        shiftTimeInfoList[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
        // 获取车辆关联便的出发时间
        let startTime = shiftTimeInfoList[i].shiftPasspointTime[0].startEstimateTime
        // 获取车辆关联便的到达时间
        let endTime = shiftTimeInfoList[i].shiftPasspointTime[shiftTimeInfoList[i].shiftPasspointTime.length - 1].arriveEstimateTime
        if (!StringUtil.isEmpty(startTime) && !StringUtil.isEmpty(endTime)) {
          if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(endDate) ||
                DateUtil.stringToDate(endTime) < DateUtil.stringToDate(startDate))) {
            return false
          }
        }
      }
      return true
    },
    // 循环入力便选择的driver被挂载到的便的时间的校验
    loopDriverValidate (startDate, endDate) {
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        if (!StringUtil.isEmpty(this.shiftList[shiftIndex].shiftBasic.driverUid)) {
          for (let i = 0; i < this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid.length; i++) {
            // 获取的时间根据sortNo进行排序
            this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
            // 获取driver关联便的出发时间
            let startTime = this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime[0].startEstimateTime
            // 获取driver关联便的到达时间
            let endTime = this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime[this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid[i].shiftPasspointTime.length - 1].arriveEstimateTime
            if (!StringUtil.isEmpty(startTime) && !StringUtil.isEmpty(endTime)) {
              if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(endDate) ||
                  DateUtil.stringToDate(endTime) < DateUtil.stringToDate(startDate))) {
                return false
              }
            }
          }
          return true
        } else {
          return true
        }
      }
    },
    // 车辆校验
    vehicleValidate () {
      console.log("vehicleValidate")
      // 使おうとしている車両がブロック状態ではないか確認する
      // ついでに二重使用もチェックする
      // 根据vehicleId获取选择的车辆的信息
      // 循环入力checkbox被勾上，则无需校验
      if (this.loopUseCheckbox) {
        return true
      }
      let errorCount = 0
      // 車両エラーをリセット
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        // 車両がブロックされている
        this.shiftList[shiftIndex].vehicleError = false
        // 同じページで同じ車両を２回以上使用している
        this.shiftList[shiftIndex].vehicleError2 = false
        // ドライバーと車両の事業者が異なる
        this.shiftList[shiftIndex].vehicleError3 = false
      }
      
      
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        for (let i = 0; i < this.vehicleInfo.length; i++) {
          if (this.vehicleInfo[i].vehicleId === this.shiftList[shiftIndex].shiftBasic.vehicleId) {
            this.shiftList[shiftIndex].selectedVehicle = this.vehicleInfo[i]
            break
          }
        }
        // 获取到选择的车辆
        if (this.shiftList[shiftIndex].selectedVehicle !== null) {
          // 车辆有被锁住的开始时间和结束时间
          if (!StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockStart) && !StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockEnd) &&
          this.shiftList[shiftIndex].selectedVehicle.blockStart.length === 14 && this.shiftList[shiftIndex].selectedVehicle.blockEnd.length === 14) {
            // 车辆的锁住开始和结束时间与便的开始时间与结束时间比较
            if (DateUtil.stringToDate(this.shiftList[shiftIndex].selectedVehicle.blockStart) > DateUtil.stringToDate(this.shiftList[shiftIndex].timeList[this.shiftList[shiftIndex].timeList.length - 1]) ||
               DateUtil.stringToDate(this.shiftList[shiftIndex].selectedVehicle.blockEnd) < DateUtil.stringToDate(this.shiftList[shiftIndex].timeList[0])) {
            } else {
              this.shiftList[shiftIndex].vehicleError = true
              errorCount++
            }
          } else {
            // 车辆没有被锁的开始时间和结束时间，校验通过
            // return true
          }
        } else {
          this.shiftList[shiftIndex].vehicleError = true
          errorCount++
          // return false
        }
        // 車両二重使用をチェック
        for(let shiftIndex2 = 0; shiftIndex2 < this.shiftList.length; shiftIndex2++){
          if(shiftIndex != shiftIndex2){
            if(this.shiftList[shiftIndex].shiftBasic.vehicleId==this.shiftList[shiftIndex2].shiftBasic.vehicleId){
              this.shiftList[shiftIndex].vehicleError2 = true
              this.shiftList[shiftIndex2].vehicleError2 = true
              errorCount++
            }
          }
        }
        // ドライバーと車両の事業者が一致しているかチェック
        if(this.shiftList[shiftIndex].shiftBasic.transportKind == 1){
          if((this.shiftList[shiftIndex].shiftBasic.vehicleTransportId != null) && (this.shiftList[shiftIndex].shiftBasic.driverTransportId != null)){
            if(this.shiftList[shiftIndex].shiftBasic.vehicleTransportId != this.shiftList[shiftIndex].shiftBasic.driverTransportId){
                this.shiftList[shiftIndex].vehicleError3 = true
                errorCount++
            }
          }
        }
      }
      if(errorCount > 0){
        return false
      }else{
        return true
      }
    },
    
    // 接続情報をグループ化
    shiftConnectValidate () {
      console.log("shiftConnectValidate")
      // 既にエラーメッセージが出ていたらfalse
      for(let i = 0; i < this.shiftConnectList.length; i++){
        if(this.shiftConnectList[i].frontShiftConnect.errorMessage != "" && this.shiftConnectList[i].frontShiftConnect.errorMessage != null){
          console.log("エラーメッセージあり")
          return false
        }
        if(this.shiftConnectList[i].shiftConnect.errorMessage != "" && this.shiftConnectList[i].shiftConnect.errorMessage != null){
          console.log("エラーメッセージあり")
          return false
        }
      }

      // すべての便に区域内便の日付を割り当て
      for(let i = 1; i < this.shiftList.length; i++){
        this.shiftList[i].shiftBasic.moveShiftTime = this.shiftList[0].shiftBasic.moveShiftTime
      }

      this.connectTimeError = false
      // parentShiftIdを作成
      for(let i=0; i < this.shiftConnectList.length; i++){
        for(let j=1; j< this.shiftList.length; j++){
          // 区域内便以外で実施
          if(this.functionFlag != '1'){
            if(this.shiftList[j].frontId === this.shiftConnectList[i].frontShiftConnect.shiftId){
              this.shiftList[j].shiftBasic.parentShiftId = this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId
            }
          }else{
            if(this.shiftList[j].shiftBasic.shiftId === this.shiftConnectList[i].frontShiftConnect.shiftId){
              this.shiftList[j].shiftBasic.parentShiftId = this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId
            }
          }
        }
      }
      // 接続グループ作成
      let connectGroup = []
      let sourceStation = {}
      let connectStation = {}
      let connectFound = false
      let connectIdNext = []
      let connectIdTemp = []
      let connectDepth = 0
      let connectStationId = 0

      this.connectGroupList = []
      for(let i=0; i < this.shiftConnectList.length; i++){
        connectGroup = []
        connectIdNext = []
        connectIdTemp = []
        connectDepth = 0
        connectStationId = 0

        if(this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId == this.parentShiftId){
          // 便名取得
          sourceStation = {}
          sourceStation.title = this.shiftList[0].shiftBasic.title
          sourceStation.shiftId = this.parentShiftId

          for(let j = 0; j < this.shiftList[0].stationList.length; j++){
            if(this.shiftList[0].stationList[j].stationId == this.shiftConnectList[i].frontShiftConnect.connectSourceStationId){
              // 接続元停留所番号取得
              sourceStation.stationIndex = j
            }
          }
          // 停留所番号から停留所名と時刻取得
          sourceStation.stationTime = this.shiftList[0].timeList[sourceStation.stationIndex]
          sourceStation.stationName = this.shiftList[0].stationList[sourceStation.stationIndex].stationName
          sourceStation.connectType = 0
          sourceStation.depth = connectDepth
          sourceStation.connectIndex = i
          sourceStation.connectStationId = connectStationId
          connectStationId++
          connectIdNext.push(this.shiftConnectList[i].frontShiftConnect.shiftId)
          connectFound = true
          connectGroup.push(sourceStation)

          // 接続先情報
          for(let k = 0; k < this.shiftList.length; k++){
            let targetId
            if(this.shiftList[k].functionFlag != '1'){
              // 新規の便なら
              targetId = this.shiftList[k].frontId
            }else{
              // 既存の便なら
              targetId = this.shiftList[k].shiftBasic.shiftId
            }
            if(targetId == this.shiftConnectList[i].frontShiftConnect.shiftId){
              // 便名取得
              connectStation = {}
              connectStation.title = this.shiftList[k].shiftBasic.title
              connectStation.shiftId = targetId
              for(let m = 0; m < this.shiftList[k].stationList.length; m++){
                if(this.shiftList[k].stationList[m].stationId == this.shiftConnectList[i].frontShiftConnect.stationId){
                  // 停留所番号取得
                  connectStation.stationIndex = m
                }
              }
              // 停留所番号から停留所名と時刻取得
              connectStation.connectSourceShiftId = sourceStation.shiftId
              connectStation.stationTime = this.shiftList[k].timeList[connectStation.stationIndex]
              connectStation.stationName = this.shiftList[k].stationList[connectStation.stationIndex].stationName
              connectStation.connectType = 1
              connectStation.depth = connectDepth
              connectStation.connectIndex = i
              connectStation.connectStationId = connectStationId
              connectStationId++
              connectFound = true
              connectGroup.push(connectStation)
            }
          }

          let loopCount = 0
          while(connectFound){
            connectFound = false
            // 接続情報ループ
            connectDepth++
            for(let o=0; o < connectIdNext.length; o++){
              for(let k=0; k < this.shiftConnectList.length; k++){
                  if(this.shiftConnectList[k].frontShiftConnect.connectSourceShiftId == connectIdNext[o]){
                    // 便情報ループ
                    for(let l= 0; l<this.shiftList.length; l++){
                      let targetId
                      if(this.shiftList[l].functionFlag != '1'){
                        // 新規の便なら
                        targetId = this.shiftList[l].frontId
                      }else{
                        // 既存の便なら
                        targetId = this.shiftList[l].shiftBasic.shiftId
                      }
                      if(targetId == connectIdNext[o]){
                        // 便名取得
                        sourceStation = {}
                        sourceStation.title = this.shiftList[l].shiftBasic.title
                        // sourceStation.shiftId = this.shiftList[l].frontId
                        sourceStation.shiftId = targetId
    
                        for(let m = 0; m < this.shiftList[l].stationList.length; m++){
                          if(this.shiftList[l].stationList[m].stationId == this.shiftConnectList[k].frontShiftConnect.connectSourceStationId){
                            // 停留所番号取得
                            sourceStation.stationIndex = m
                          }
                        }

                        // 接続元チェック
                        for(let m=0; m<this.shiftConnectList.length; m++){
                          if(this.shiftConnectList[k].frontShiftConnect.connectSourceShiftId == this.shiftConnectList[m].frontShiftConnect.shiftId){
                            sourceStation.connectSourceShiftId = this.shiftConnectList[m].frontShiftConnect.shiftId
                          }
                        }

                        // 停留所番号から停留所名と時刻取得
                        sourceStation.stationTime = this.shiftList[l].timeList[sourceStation.stationIndex]
                        sourceStation.stationName = this.shiftList[l].stationList[sourceStation.stationIndex].stationName
                        sourceStation.connectType = 0
                        sourceStation.depth = connectDepth
                        sourceStation.connectIndex = k
                        sourceStation.connectStationId = connectStationId
                        connectStationId++
                        connectIdTemp.push(this.shiftConnectList[k].frontShiftConnect.shiftId)
                        connectFound = true
                        connectGroup.push(sourceStation)
    
                        // 接続先
                        for(let n = 0; n < this.shiftList.length; n++){
                          let targetId
                          if(this.shiftList[n].functionFlag != '1'){
                            // 新規の便なら
                            targetId = this.shiftList[n].frontId
                          }else{
                            // 既存の便なら
                            targetId = this.shiftList[n].shiftBasic.shiftId
                          }
                          if(targetId == this.shiftConnectList[k].frontShiftConnect.shiftId){
                            // 便名取得
                            connectStation = {}
                            connectStation.title = this.shiftList[n].shiftBasic.title
                            connectStation.shiftId = targetId
                            for(let m = 0; m < this.shiftList[n].stationList.length; m++){
                              if(this.shiftList[n].stationList[m].stationId == this.shiftConnectList[k].frontShiftConnect.stationId){
                                // 停留所番号取得
                                connectStation.stationIndex = m
                              }
                            }
                            // 停留所番号から停留所名と時刻取得
                            connectStation.connectSourceShiftId = sourceStation.shiftId
                            connectStation.stationTime = this.shiftList[n].timeList[connectStation.stationIndex]
                            connectStation.stationName = this.shiftList[n].stationList[connectStation.stationIndex].stationName
                            connectStation.connectType = 1
                            connectStation.depth = connectDepth
                            connectStation.connectIndex = k
                            connectStation.connectStationId = connectStationId
                            connectStationId++
                            connectFound = true
                            connectGroup.push(connectStation)
                          }
                        }
                        break
                      }
                    }
                  }
              }
            }
            connectIdNext = connectIdTemp
            connectIdTemp = []
            // 無限ループ防止
            loopCount++
            if(loopCount > 100){
              connectFound = false
              console.log("無限ループに突入しました")
              return false
            }
          }
          
          connectGroup.maxDepth = connectDepth
          console.log("connectGroupPush")
          console.log(connectGroup)
          this.connectGroupList.push(connectGroup)

        }
      }

      // 接続情報に列番号を付与
      let connectColumn = 0
      let depthShiftList = []
      let currentColumn = 0
      let connectMaxColumn  =0
      for(let i=0; i < this.connectGroupList.length; i++){
        connectColumn = 0
        currentColumn = 0
        connectMaxColumn  =0
        for(let depth=0; depth < this.connectGroupList[i].maxDepth; depth++){
          depthShiftList = []
          for(let k=0; k < this.connectGroupList[i].length; k++){
            connectColumn = 0
            currentColumn = 0
            if(this.connectGroupList[i][k].depth == depth){
              if(this.connectGroupList[i][k].connectType == 0){
                // まず接続元についてColumnを設定
                // 一番上の階層
                if(depth == 0){
                  this.connectGroupList[i][k].connectColumn = connectColumn
                  currentColumn = this.connectGroupList[i][k].connectColumn
                  connectMaxColumn = Math.max(connectColumn, connectMaxColumn)
                }else{
                // 二番目以降の階層
                  // 同じ階層で同じ接続元の便が他に存在する（分岐発生）
                  if(depthShiftList.includes(this.connectGroupList[i][k].connectSourceShiftId)){
                    this.connectGroupList[i][k].connectColumn  = connectMaxColumn + 1
                    currentColumn = this.connectGroupList[i][k].connectColumn
                    connectMaxColumn = Math.max(currentColumn, connectMaxColumn)
                  }else{
                    // 同じ階層に同じ接続元の便が存在しない（分岐していない）
                    // 接続元のcolumnを取得
                    for(let l=0; l < this.connectGroupList[i].length; l++){
                      if(this.connectGroupList[i][k].connectSourceShiftId == this.connectGroupList[i][l].shiftId){
                        if(this.connectGroupList[i][l].connectType == 1){
                          this.connectGroupList[i][k].connectColumn  = this.connectGroupList[i][l].connectColumn
                        }
                      }
                    }
                    currentColumn = this.connectGroupList[i][k].connectColumn
                    connectMaxColumn = Math.max(currentColumn, connectMaxColumn)
                  }
                  depthShiftList.push(this.connectGroupList[i][k].connectSourceShiftId)
                }
                // 接続先についてColumnを設定
                for(let j=0; j < this.connectGroupList[i].length; j++){
                  if(this.connectGroupList[i][j].connectType == 1){
                    for(let m=0; m < this.connectGroupList[i].length; m++){
                      if(this.connectGroupList[i][m].connectType == 0){
                        if(this.connectGroupList[i][j].connectIndex == this.connectGroupList[i][m].connectIndex){
                          this.connectGroupList[i][j].connectColumn = this.connectGroupList[i][m].connectColumn
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.connectGroupList[i].maxColumn = connectMaxColumn
      }
      console.log("this.connectGroupList")
      console.log(this.connectGroupList)

      // すべての便が接続されているかチェック
      let useCount = 0
      this.notUseShiftList = []
      for(let i=0; i < this.shiftList.length; i++){
        let targetId
        if(this.shiftList[i].functionFlag != '1'){
          // 新規の便なら
          targetId = this.shiftList[i].frontId
        }else{
          // 既存の便なら
          targetId = this.shiftList[i].shiftBasic.shiftId
        }
        useCount = 0
        for(let j=0; j < this.connectGroupList.length; j++){
          for(let k=0; k < this.connectGroupList[j].length; k++){
            if(targetId == this.connectGroupList[j][k].shiftId){
              useCount++
            }
            if(targetId == this.connectGroupList[j][k].connectSourceShiftId){
              useCount++
            }
          }
        }
        if(useCount == 0){
          console.log(this.shiftList[i].shiftBasic.title + "が使用されていません。")
          this.notUseShiftList.push(this.shiftList[i].shiftBasic.title)
          return false
        }
      }

      // 時刻チェック
      for(let x = 0; x < this.shiftConnectList.length; x++){
        this.shiftConnectList[x].frontShiftConnect.timeError = 0
      }
    
      for(let i= 0; i < this.connectGroupList.length; i++){
        for(let depth=0; depth<this.connectGroupList[i].maxDepth; depth++){
          for(let column=0; column<this.connectGroupList[i].maxColumn + 1; column++){
            // 接続元
            if(depth > 0){
              let sourceStation
              let connectStation
              // 行き
              if(this.shiftList[0].shiftBasic.shiftFlag === '0'){
                sourceStation = this.getConnectStationByCoordinate(i, depth-1, column, 1)
                connectStation = this.getConnectStationByCoordinate(i, depth, column, 0)
              }else if(this.shiftList[0].shiftBasic.shiftFlag === '1'){
                // 帰り
                sourceStation= this.getConnectStationByCoordinate(i, depth, column, 0)
                connectStation = this.getConnectStationByCoordinate(i, depth-1, column, 1)
              }
              if(sourceStation != null && connectStation != null){
                if(sourceStation.stationTime >= connectStation.stationTime){
                  console.log("接続時刻エラー[" + sourceStation.stationTime + "]→[" + connectStation.stationTime + "]")
                  this.shiftConnectList[connectStation.connectIndex].frontShiftConnect.timeError = 1
                  this.connectTimeError = true
                  return false
                }
              }
            }
            // 接続先
            let sourceStation
            let connectStation
            // 行き
            if(this.shiftList[0].shiftBasic.shiftFlag === '0'){
              sourceStation = this.getConnectStationByCoordinate(i, depth, column, 0)
              connectStation = this.getConnectStationByCoordinate(i, depth, column, 1)
            }else if(this.shiftList[0].shiftBasic.shiftFlag === '1'){
              // 帰り
              sourceStation= this.getConnectStationByCoordinate(i, depth, column, 1)
              connectStation = this.getConnectStationByCoordinate(i, depth, column, 0)
            }
            if(sourceStation != null && connectStation != null){
              if(sourceStation.stationTime >= connectStation.stationTime){
                console.log("接続時刻エラー[" + sourceStation.stationTime + "]→[" + connectStation.stationTime + "]")
                this.shiftConnectList[connectStation.connectIndex].frontShiftConnect.timeError = 2
                this.connectTimeError = true
                return false
              }
            }
          }
        }
      }

      // 確認モーダル表示用のHTML作成
      let connectItemFound = false
      let arrow = ''
      let columnWidth = 100
      if(this.shiftList[0].shiftBasic.shiftFlag == 0){
        arrow = '↓'
      }else{
        arrow = '↑'
      }
      this.connectGroupHtml = ''
      for(let i= 0; i < this.connectGroupList.length; i++){
        columnWidth = 100 / (this.connectGroupList[i].maxColumn + 1)
        this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-group">'
        for(let depth=0; depth<this.connectGroupList[i].maxDepth; depth++){
          // 接続元
          this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-row">'
          for(let column=0; column<this.connectGroupList[i].maxColumn + 1; column++){
            connectItemFound = false
            for(let j=0; j<this.connectGroupList[i].length; j++){
              if(this.connectGroupList[i][j].connectType == 0 && this.connectGroupList[i][j].depth == depth && this.connectGroupList[i][j].connectColumn == column){
                this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-item" style="width : ' + columnWidth + '%;">'
                if(this.connectGroupList[i][j].connectSourceShiftId != null){
                  this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-arrow">' + arrow + '</div>'
                }
                this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-station">' +this.connectGroupList[i][j].title + '<br>' + this.connectGroupList[i][j].stationName + '<br>' + this.getHourMin(this.connectGroupList[i][j].stationTime) + '</div>'
                this.connectGroupHtml = this.connectGroupHtml + '</div>'
                connectItemFound = true
              }
            }
            if(!connectItemFound){
              this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-item" style="width : ' + columnWidth + '%;"></div>'
            }
          }
          this.connectGroupHtml = this.connectGroupHtml + '</div>'
          
          // 接続先
          this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-row">'
          for(let column=0; column<this.connectGroupList[i].maxColumn + 1; column++){
            connectItemFound = false
            for(let j=0; j<this.connectGroupList[i].length; j++){
              if(this.connectGroupList[i][j].connectType == 1 && this.connectGroupList[i][j].depth == depth && this.connectGroupList[i][j].connectColumn == column){
                this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-item" style="width : ' + columnWidth + '%;">'
                if(this.connectGroupList[i][j].connectSourceShiftId != null){
                  this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-arrow">' + arrow + '</div>'
                }
                this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-station">' +this.connectGroupList[i][j].title + '<br>' + this.connectGroupList[i][j].stationName + '<br>' + this.getHourMin(this.connectGroupList[i][j].stationTime) + '</div>'
                this.connectGroupHtml = this.connectGroupHtml + '</div>'
                connectItemFound = true
              }
            }
            if(!connectItemFound){
              // 分岐確認
              for(let k=0; k<this.connectGroupList[i].length; k++){
                // 1つ下のアイテムを探索
                if(this.connectGroupList[i][k].connectType == 0 && this.connectGroupList[i][k].depth == depth + 1 && this.connectGroupList[i][k].connectColumn == column){
                  // それが空ではない すなわち分岐が発生しているなら
                  if(this.connectGroupList[i][k].connectSourceShiftId != null){
                    // 同じ階層からその接続元IDのアイテムを探索して表示
                    for(let l=0; l<this.connectGroupList[i].length; l++){
                      if(this.connectGroupList[i][l].connectType == 1 && this.connectGroupList[i][l].depth == depth && this.connectGroupList[i][l].shiftId == this.connectGroupList[i][k].connectSourceShiftId){
                        this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-item connect-branch" style="width : ' + columnWidth + '%;">'
                        this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-arrow">（分岐）</div>'
                        this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-station">' +this.connectGroupList[i][l].title + '<br>' + this.connectGroupList[i][l].stationName + '<br>' + this.getHourMin(this.connectGroupList[i][l].stationTime) + '</div>'
                        this.connectGroupHtml = this.connectGroupHtml + '</div>'
                      }
                    }
                  }else{
                    // 分岐がなかったら
                    this.connectGroupHtml = this.connectGroupHtml + '<div class="connect-item" style="width : ' + columnWidth + '%;"></div>'
                  }
                }
              }
            }
          }
          this.connectGroupHtml = this.connectGroupHtml + '</div>'
        }
        this.connectGroupHtml = this.connectGroupHtml + '</div>'
      }
      this.connectTimeError = false
      return true
    },
    //depthとcolumnからconnectStationを取り出す
    getConnectStationByCoordinate(i, depth, column, type){
      for(let connectGroupIndex = 0; connectGroupIndex < this.connectGroupList[i].length; connectGroupIndex++){
        if(this.connectGroupList[i][connectGroupIndex].depth == depth && this.connectGroupList[i][connectGroupIndex].connectColumn == column && this.connectGroupList[i][connectGroupIndex].connectType == type){
          let connectStation = this.connectGroupList[i][connectGroupIndex]
          return connectStation
        }
      }
      return null
    },

    // エラー一覧作成
    makeErrorList() {
      console.log("makeErrorList")
      let errorItem = {}
      this.shiftErrorList = []
      this.connectErrorList = []
      for(let i=0; i < $(".shiftItem").length; i++){
        if($(".shiftItem").eq(i).find(".errorMessage").length > 0){
          errorItem = {}
          errorItem.title = this.shiftList[i].shiftBasic.title
          errorItem.index = i
          this.shiftErrorList.push(errorItem)
        }
      }
      for(let i=0; i < $(".connectItem").length; i++){
        if($(".connectItem").eq(i).find(".errorMessage").length > 0){
          errorItem = {}
          errorItem.index = i
          this.connectErrorList.push(errorItem)
        }
      }
      if(this.shiftErrorList.length > 0 || this.connectErrorList.length > 0 || this.connectTimeError === true || this.notUseShiftList.length > 0 ){
        this.scrollToAnchorPoint('errorlist-area')
      }
    },

    // 选择的车辆被挂载到的便的时间的校验
    // 車両スケジュール重複チェック 編集画面用
    editorShiftVehiclValidate (shiftTimeInfoList) {
      console.log("editorShiftVehiclValidate")
      let errorCount = 0
      // 車両エラーをリセット
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        this.shiftList[shiftIndex].vehicleError = false
      }
      
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        // 获取当前便的开始时间
        let currentShiftStartTime = this.shiftList[shiftIndex].timeList[0]
        // 获取当前便的结束时间
        let currentShiftEndTime = this.shiftList[shiftIndex].timeList[this.shiftList[shiftIndex].timeList.length - 1]

        for (let i = 0; i < this.shiftList[shiftIndex].shiftTimeInfoList.length; i++) {
          // this.shiftList[shiftIndex].vehicleError = false
          if(this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftId != this.shiftList[shiftIndex].shiftBasic.shiftId){
            // 获取的时间根据sortNo进行排序
            this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
            // 获取车辆关联便的出发时间
            let startTime = this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime[0].startEstimateTime
            // 获取车辆关联便的到达时间
            let endTime = this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime[this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftPasspointTime.length - 1].arriveEstimateTime
            if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
              if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                    DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
                      console.log("this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftId")
                      console.log(this.shiftList[shiftIndex].shiftTimeInfoList[i].shiftId)
                      console.log(this.shiftList[shiftIndex].shiftBasic.shiftId)
                this.shiftList[shiftIndex].vehicleError = true
                errorCount++
              }
            }
          }
        }
      }
      if(errorCount > 0){
        return false
      }else{
        return true
      }
    },

    // 选择的driver被挂载到的便的时间的校验
    // 編集画面用 ドライバー重複チェック
    editorShiftDriverValidate () {
      console.log("editorShiftDriverValidate")
      let errorCount = 0
      // ドライバーエラーをリセット
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        this.shiftList[shiftIndex].driverError = false
      }
      for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
        if(this.shiftList[shiftIndex].functionFlag == '1' || this.functionFlag == '3'){
          let editorShiftTimeInfoListByDriverUid = this.shiftList[shiftIndex].shiftTimeInfoListByDriverUid.filter((item) => item.shiftId !== this.shiftList[shiftIndex].shiftBasic.shiftId)
          if (!StringUtil.isEmpty(this.shiftList[shiftIndex].shiftBasic.driverUid)) {
          // 获取当前便的开始时间
            let currentShiftStartTime = this.shiftList[shiftIndex].timeList[0]
            // 获取当前便的结束时间
            let currentShiftEndTime = this.shiftList[shiftIndex].timeList[this.shiftList[shiftIndex].timeList.length - 1]
            for (let i = 0; i < editorShiftTimeInfoListByDriverUid.length; i++) {
              // 获取的时间根据sortNo进行排序
              editorShiftTimeInfoListByDriverUid[i].shiftPasspointTime.sort((a, b) => { return a.sortNo - b.sortNo })
              // 获取车辆关联便的出发时间
              let startTime = editorShiftTimeInfoListByDriverUid[i].shiftPasspointTime[0].startEstimateTime
              // 获取车辆关联便的到达时间
              let endTime = editorShiftTimeInfoListByDriverUid[i].shiftPasspointTime[editorShiftTimeInfoListByDriverUid[i].shiftPasspointTime.length - 1].arriveEstimateTime
              if (!StringUtil.isEmpty(startTime) && (startTime.length === 14) && !StringUtil.isEmpty(endTime) && (endTime.length === 14)) {
                if (!(DateUtil.stringToDate(startTime) > DateUtil.stringToDate(currentShiftEndTime) ||
                    DateUtil.stringToDate(endTime) < DateUtil.stringToDate(currentShiftStartTime))) {
                  // this.showMessage(this.driverMessage)
                  this.shiftList[shiftIndex].driverError = true
                  errorCount++
                  // return false
                }
              }
            }
          }
        }
      }
      if(errorCount > 0){
        return false
      }else{
        return true
      }

    },

    // 计算循环入力便的日期的集合
    getLoopDateList () {
      // 需要生成便的日期的集合
      let dateList = []
      // 勾选周日的场合
      if (this.sundayCheckbox) {
        let sundayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 0)
        for (let i = 0; i < sundayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(sundayDateList[i])
        }
      }
      // 勾选周一的场合
      if (this.mondayCheckbox) {
        let mondayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 1)
        for (let i = 0; i < mondayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(mondayDateList[i])
        }
      }
      // 勾选周二的场合
      if (this.tuesdayCheckbox) {
        let tuesdayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 2)
        for (let i = 0; i < tuesdayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(tuesdayDateList[i])
        }
      }
      // 勾选周三的场合
      if (this.wednesdayCheckbox) {
        let wednesdayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 3)
        for (let i = 0; i < wednesdayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(wednesdayDateList[i])
        }
      }
      // 勾选周四的场合
      if (this.thursdayCheckbox) {
        let thursdayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 4)
        for (let i = 0; i < thursdayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(thursdayDateList[i])
        }
      }
      // 勾选周五的场合
      if (this.fridayCheckbox) {
        let fridayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 5)
        for (let i = 0; i < fridayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(fridayDateList[i])
        }
      }
      // 勾选周六的场合
      if (this.saturdayCheckbox) {
        let saturdayDateList = DateUtil.getWeekDateList(this.startTime, this.endTime, 6)
        for (let i = 0; i < saturdayDateList.length; i = i + parseInt(this.weekIntervalNum)) {
          dateList.push(saturdayDateList[i])
        }
      }
      // 将集合中的日期进行排序
      dateList.sort((a, b) => { return a - b })
      // 或许当前运行开始日
      // let moveShiftDate = DateUtil.shortStringToDate(this.shiftBasicModel.moveShiftTime)
      // 过滤出不等于已选择的运行开始日的日期
      // let tempDateList = []
      let stringDateList = []
      // tempDateList = dateList.filter(item => item.getTime() !== moveShiftDate.getTime())
      // dateList : 繰り返し登録する予定のすべての日付
      for (let i = 0; i < dateList.length; i++) {
        // stringDateList.push(formatDate(tempDateList[i], 'yyyyMMdd'))
        let tempDate = formatDate(dateList[i], 'yyyyMMdd')
        // 循环入力便的开始时间
        let startDate = tempDate + this.shiftList[0].timeList[0].substring(8, 14)
        // 循环入力便的结束时间
        let endDate = tempDate + this.shiftList[0].timeList[this.shiftList[0].timeList.length - 1].substring(8, 14)
        // 繰り返し登録のすべての日付でドライバーのシフトが空いているか確認する
        if (!this.loopDriverValidate(startDate, endDate)) {
          continue
        }
        let canPushTempDate = false
        for(let shiftIndex = 0; shiftIndex < this.shiftList.length; shiftIndex++){
          canPushTempDate = false
          if (this.shiftList[shiftIndex].selectedVehicle !== null) {
            // その車両にブロックの日付が設定されている
            if (!StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockStart) && !StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockEnd)) {
              // 登録したい日付がブロック期間外なら
              if (DateUtil.stringToDate(this.shiftList[shiftIndex].selectedVehicle.blockStart) > DateUtil.stringToDate(endDate) ||
                  DateUtil.stringToDate(this.shiftList[shiftIndex].selectedVehicle.blockEnd) < DateUtil.stringToDate(startDate)) {
                // 
                if (this.loopVehicleValidate(this.shiftList[shiftIndex].shiftTimeInfoList, startDate, endDate)) {
                  // 日付を追加
                  // stringDateList.push(tempDate)
                  canPushTempDate = true
                }
              }
            } else if (StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockStart) && StringUtil.isEmpty(this.shiftList[shiftIndex].selectedVehicle.blockEnd)) {
              // その車両にブロックの日付が設定されていない
              if (this.loopVehicleValidate(this.shiftList[shiftIndex].shiftTimeInfoList, startDate, endDate)) {
                // 两个条件都满足，则放到stringDateList中
                // stringDateList.push(tempDate)
                canPushTempDate = true
              }
            }
          }
        }
        if(canPushTempDate){
          stringDateList.push(tempDate)
        }
      }
      return stringDateList
    },
    // event 作成
    eventMake () {
      // 便を登録的场合
      // 便为定期便
      if (this.functionFlag === '0') {
        console.log("eventMake func0")
        if (this.routeSelected) {
          // 将出发地和终着地时间校验标志位置为true，触发子组件的校验
          this.$refs.stationCom[0].triggerValidate()
          this.$refs.stationCom[0].$validator.validateAll()
        }
        this.$validator.validateAll().then(result => {
          if (result) {
            // 将出发地和终着地时间校验标志位置为true，触发子组件的校验
            this.$refs.stationCom[0].$validator.validateAll().then(result => {
              if (result) {
                // 停留所时间校验
                if (this.stationTimeValidate()) {
                  console.log("stationTimeValidate ok")

                  // hour minute 时间拼接
                  if (this.timeCombination()) {
                    if (this.shiftDriverValidate()) {
                    // 车辆验证
                      if (this.vehicleValidate()) {
                        if (this.shiftVehiclValidate()) {
                          // 接続確認
                          let connectCheck = false
                          if(this.shiftList.length > 1){
                            connectCheck = this.shiftConnectValidate()
                          }else{
                            connectCheck = true
                          }
                          if(connectCheck){
                            // 便経由地情報集合赋值
                            this.getShiftPasspointList()
                            if (this.loopUseCheckbox) {
                              if (this.startEndTimeValidate()) {
                                let loopData = {}
                                loopData.loopUseCheckbox = this.loopUseCheckbox
                                loopData.mondayCheckbox = this.mondayCheckbox
                                loopData.tuesdayCheckbox = this.tuesdayCheckbox
                                loopData.wednesdayCheckbox = this.wednesdayCheckbox
                                loopData.thursdayCheckbox = this.thursdayCheckbox
                                loopData.fridayCheckbox = this.fridayCheckbox
                                loopData.saturdayCheckbox = this.saturdayCheckbox
                                loopData.sundayCheckbox = this.sundayCheckbox
                                loopData.startTime = formatDate(this.startTime, 'yyyyMMdd')
                                loopData.endTime = formatDate(this.endTime, 'yyyyMMdd')
                                loopData.weekIntervalNum = this.weekIntervalNum
                                // 循环session
                                sessionStorage.setItem('loopData', JSON.stringify(loopData))
                                // 便基本情報存放到session中
                                // this.shiftBasicModel.shiftType = '2'
                                this.shiftList[0].shiftBasic.shiftType = '2'
                                sessionStorage.setItem('shiftBasicModel', JSON.stringify(this.shiftBasicModel))
                                // 便経由地情報集合放到session中
                                sessionStorage.setItem('shiftPasspointList', JSON.stringify(this.shiftPasspoint))
                                // hourList放到session中
                                sessionStorage.setItem('hourList', JSON.stringify(this.hourList))
                                // minuteList
                                sessionStorage.setItem('minuteList', JSON.stringify(this.minuteList))
                                // loopDateList
                                sessionStorage.setItem('loopDateList', JSON.stringify(this.loopDateList))
  
                                // 区域外対応
                                sessionStorage.setItem('shiftList', JSON.stringify(this.shiftList))
                                sessionStorage.setItem('removeShiftList', JSON.stringify(this.removeShiftList))
                                if(this.shiftList.length > 1){
                                  sessionStorage.setItem('shiftConnectList', JSON.stringify(this.shiftConnectList))
                                  sessionStorage.setItem('connectGroupList', JSON.stringify(this.connectGroupList))
                                  sessionStorage.setItem('connectGroupHtml', JSON.stringify(this.connectGroupHtml))
                                }else{
                                  sessionStorage.removeItem('shiftConnectList')
                                  sessionStorage.removeItem('connectGroupList')
                                  sessionStorage.removeItem('connectGroupHtml')
                                }
  
                                this.$router.push({path: '/EventGenerate', query: {flag: this.functionFlag}})
                              }
                            } else {
                            // 便基本情報存放到session中
                              // this.shiftBasicModel.shiftType = '2'
                              this.shiftList[0].shiftBasic.shiftType = '2'
                              sessionStorage.setItem('shiftBasicModel', JSON.stringify(this.shiftList[0].shiftBasic))
                              // 便経由地情報集合放到session中
                              sessionStorage.setItem('shiftPasspointList', JSON.stringify(this.shiftPasspoint))
                              // hourList放到session中
                              sessionStorage.setItem('hourList', JSON.stringify(this.hourList))
                              // minuteList
                              sessionStorage.setItem('minuteList', JSON.stringify(this.minuteList))
  
  
                              // 区域外対応
                              sessionStorage.setItem('shiftList', JSON.stringify(this.shiftList))
                              if(this.shiftList.length > 1){
                                sessionStorage.setItem('shiftConnectList', JSON.stringify(this.shiftConnectList))
                                sessionStorage.setItem('connectGroupList', JSON.stringify(this.connectGroupList))
                                sessionStorage.setItem('connectGroupHtml', JSON.stringify(this.connectGroupHtml))
                              }else{
                                sessionStorage.removeItem('shiftConnectList')
                                sessionStorage.removeItem('connectGroupList')
                                sessionStorage.removeItem('connectGroupHtml')
                              }
  
                              // 未勾选循环入力checkbox 清除循环入力的相关缓存
                              if (sessionStorage.getItem('loopData') !== null) {
                                sessionStorage.removeItem('loopData')
                              }
                              if (sessionStorage.getItem('loopDateList') !== null) {
                                sessionStorage.removeItem('loopDateList')
                              }
                              this.$router.push({path: '/EventGenerate', query: {flag: this.functionFlag}})
                            }
                          }
                        } else {
                        // 车辆选择不正确的场合，将其置为空
                          this.shiftBasicModel.vehicleId = ''
                        }
                      } else {
                      // 车辆选择不正确的场合，将其置为空
                        this.shiftBasicModel.vehicleId = ''
                      }
                    } else {
                      // driver选择不正确的场合，将其置为空
                      this.shiftBasicModel.driverUid = ''
                      this.shiftBasicModel.driverName = ''
                      this.shiftBasicModel.driverKanaName = ''
                    }
                  }
                }
              }
            })
          }
        })
      } else if (this.functionFlag === '1') {
        console.log("eventMake func1")

        // 便を编辑的场合
        // 将出发地和终着地时间校验标志位置为true，触发子组件的校验
        this.$refs.passpointCom[0].triggerValidate()
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$refs.passpointCom[0].$validator.validateAll().then(result => {
              if (result) {
                // 停留所时间校验
                if (this.stationTimeValidate()) {
                  console.log("stationTimeValidate ok")
                  if (this.editorTimeCombination()) {
                    console.log("editorTimeCombination ok")
                    // 驾驶员验证
                    for(let i = 0; i < this.shiftList.length; i++){
                      if(this.shiftList[i].functionFlag == '1'){
                        this.$refs.passpointCom[i].savePasspoints(this.shiftList[i].shiftBasic.moveShiftTime, i)
                      }
                    }
                    if (this.shiftDriverValidate() && this.editorShiftDriverValidate()) {
                    console.log("shiftDriverValidate ok")
                    console.log("editorShiftDriverValidate ok")

                        if (this.vehicleValidate()) {
                        console.log("vehicleValidate ok")
                        if (this.editorShiftVehiclValidate()) {
                          console.log("editorShiftVehiclValidate ok")

                          let connectCheck = false
                          console.log("connectCheck")
                          if(this.shiftList.length > 1){
                            connectCheck = this.shiftConnectValidate()
                            // すべての便に区域内便の日付を割り当て
                            for(let i = 1; i < this.shiftList.length; i++){
                              this.shiftList[i].shiftBasic.moveShiftTime = this.shiftList[0].shiftBasic.moveShiftTime
                            }
                          }else{
                            connectCheck = true
                          }
                          if(connectCheck){
                            this.getShiftPasspointList()

                            // 将修改后便信息进行封装，并存放在session中，以供返回时保持数据
                            let shiftInfo = {}
                            shiftInfo.shiftId = this.shiftList[0].shiftBasic.shiftId
                            shiftInfo.parentShiftId = this.shiftList[0].shiftBasic.shiftId
                            shiftInfo.title = this.shiftList[0].shiftBasic.title
                            shiftInfo.routeId = this.shiftList[0].shiftBasic.routeId
                            shiftInfo.driveUid = this.shiftList[0].shiftBasic.driverUid
                            shiftInfo.driverNameKana = this.shiftList[0].shiftBasic.driverKanaName
                            shiftInfo.driverName = this.shiftList[0].shiftBasic.driverName
                            shiftInfo.vehicleId = this.shiftList[0].shiftBasic.vehicleId
                            shiftInfo.vehicleName = this.shiftList[0].shiftBasic.vehicleName
                            shiftInfo.passengerNumber = this.shiftList[0].shiftBasic.passengerNumber
                            shiftInfo.moveShiftTime = DateUtil.yearWeek(this.shiftList[0].shiftBasic.moveShiftTime)
                            shiftInfo.shiftFlag = Number(this.shiftList[0].shiftBasic.shiftFlag)
                            if (this.shiftList[0].shiftBasic.shiftFlag === '0') {
                              shiftInfo.startEstimateTimeSlot = this.shiftList[0].shiftBasic.startEstimateTimeSlot
                            } else {
                              shiftInfo.arriveEstimateTimeSlot = this.shiftList[0].shiftBasic.arriveEstimateTimeSlot
                            }
                            shiftInfo.shiftCost = this.shiftList[0].shiftBasic.shiftCost
                            shiftInfo.reserveNumber = this.shiftList[0].shiftBasic.reserveNumber
                            shiftInfo.eventId = this.shiftList[0].shiftBasic.eventId
                            shiftInfo.shiftType = this.shiftList[0].shiftBasic.shiftType
                            shiftInfo.areaId = this.shiftList[0].shiftBasic.areaId
                            shiftInfo.areaName = this.shiftList[0].shiftBasic.areaName
                            shiftInfo.shiftMovementStatus = this.shiftList[0].shiftBasic.shiftMovementStatus
                            shiftInfo.businessStatus = this.shiftList[0].shiftBasic.businessStatus
                            shiftInfo.shiftPasspoints = this.shiftPasspoint
                            shiftInfo.shiftReservationInfos = this.shiftReservationInfos
                            // 将更改更新到Session中,以便イベント作成取消时使用
                            sessionStorage.setItem('eventShiftDetail', JSON.stringify({shiftInfo: shiftInfo, shiftPasspoints: this.shiftPasspoint}))
  
                            // 便基本情報存放到session中
                            this.shiftList[0].shiftBasic.shiftType = '2'
                            sessionStorage.setItem('shiftBasicModel', JSON.stringify(this.shiftList[0].shiftBasic))
                            // sessionStorage.setItem('shiftBasicModel', JSON.stringify(this.shiftBasicModel))
                            // 便経由地情報集合放到session中
                            sessionStorage.setItem('shiftPasspointList', JSON.stringify(this.shiftList[0].shiftPasspointList))
                            // sessionStorage.setItem('shiftPasspointList', JSON.stringify(this.shiftPasspoint))
                            sessionStorage.setItem('shiftReservationInfoList', JSON.stringify(this.shiftList[0].shiftReservationInfoList))
                            // sessionStorage.setItem('shiftReservationInfoList', JSON.stringify(this.shiftReservationInfos))

                            // 区域外対応
                            sessionStorage.setItem('shiftList', JSON.stringify(this.shiftList))
                            if(this.shiftList.length > 1){
                              sessionStorage.setItem('shiftConnectList', JSON.stringify(this.shiftConnectList))
                              sessionStorage.setItem('connectGroupList', JSON.stringify(this.connectGroupList))
                              sessionStorage.setItem('connectGroupHtml', JSON.stringify(this.connectGroupHtml))
                            }else{
                              sessionStorage.removeItem('shiftConnectList')
                              sessionStorage.removeItem('connectGroupList')
                              sessionStorage.removeItem('connectGroupHtml')
                            }
                            sessionStorage.setItem('routeName', JSON.stringify(this.shiftList[0].shiftBasic.routeName))

                            this.$router.push({path: '/EventGenerate', query: {flag: this.functionFlag, from: 'ShiftEditor'}})
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
          }
        })
      }

      window.setTimeout( this.makeErrorList, 1 );
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOption.text = title
      this.dialogOption.showNo = yesNoFlag
      this.dialogOption.confirmButtonText = yesText
      this.dialogOption.cancelButtonText = noText
      this.showDialog = true
      this.$refs.dialog
        .confirm()
        .then(() => {
          this.showDialog = false
        })
        .catch(() => {
          this.showDialog = false
        })
    },
    // 便経由地情報集合赋值
    getShiftPasspointList () {
      this.shiftList.forEach(item => {
        if(item.functionFlag != '1'){
          item.shiftPasspointList = item.stationList
  
          for(let i = 0; i < item.stationList.length; i++){
            // 行き
            if(this.shiftList[0].shiftBasic.shiftFlag === '0'){
              if(i === 0){
                item.shiftBasic.startEstimateTimeSlot = item.timeList[i]
                item.shiftPasspointList[i].startEstimateTime = item.timeList[i]
              } else {
                item.shiftPasspointList[i].arriveEstimateTime = item.timeList[i]
              }
            // 帰り
            } else if(this.shiftList[0].shiftBasic.shiftFlag === '1'){
              if(i === 0){
                item.shiftPasspointList[i].startEstimateTime = item.timeList[i]
              } else if(i === item.stationList.length - 1){
                item.shiftBasic.arriveEstimateTimeSlot = item.timeList[i]
                item.shiftPasspointList[i].arriveEstimateTime = item.timeList[i]
              } else {
                item.shiftPasspointList[i].arriveEstimateTime = item.timeList[i]
              }
            }
          }
        }
      });
      console.log("getShiftPasspointList")
      console.log(this.shiftList)
    },
    getEditorShiftPasspoints (passpoints, shiftReservationInfos, estimateTimeSlot, index) {
      console.log("getEditorShiftPasspoints index" + index)
      this.shiftPasspoint = passpoints
      this.shiftReservationInfos = shiftReservationInfos

      this.shiftList[index].shiftPasspointList = passpoints

      // if(this.functionFlag != '3'){
        for(let i = 0; i < this.shiftList[index].stationList.length; i++){
          if (this.shiftList[index].shiftBasic.shiftFlag === '0') {
            if(i === 0){
              this.shiftList[index].shiftBasic.startEstimateTimeSlot = estimateTimeSlot
              this.shiftList[index].shiftBasic.arriveEstimateTimeSlot = ''
              this.shiftList[index].shiftPasspointList[i].startEstimateTime = this.shiftList[index].timeList[i]
            }else{
              this.shiftList[index].shiftPasspointList[i].arriveEstimateTime = this.shiftList[index].timeList[i]
            }
          } else {
            if(i === 0){
              this.shiftList[index].shiftPasspointList[i].startEstimateTime = this.shiftList[index].timeList[i]
  
            }else if(i === this.shiftList[index].length -1){
              this.shiftList[index].shiftBasic.arriveEstimateTimeSlot = estimateTimeSlot
              this.shiftList[index].shiftBasic.startEstimateTimeSlot = ''
              this.shiftList[index].shiftPasspointList[i].arriveEstimateTime = this.shiftList[index].timeList[i]
            }else{
              this.shiftList[index].shiftBasic.arriveEstimateTimeSlot = estimateTimeSlot
              this.shiftList[index].shiftPasspointList[i].arriveEstimateTime = this.shiftList[index].timeList[i]
            }
          }
        
        }
      // }
    },
    // hour minute 时间拼接
    timeCombination () {
      // 登録ボタン押下時、確認モーダル表示直前に呼び出される
      // hourListとminuteListを結合し、timeListの値を作成する
      for(let index = 0; index < this.shiftList.length; index++){
        this.$refs.stationCom[index].timeError = false
        // 获取当前的运行日
        let moveShiftDate = this.shiftList[0].shiftBasic.moveShiftTime
        // 行き
        if (this.shiftList[0].shiftBasic.shiftFlag === '0') {
          for (let i = 0; i < this.shiftList[index].hourList.length; i++) {
            this.shiftList[index].timeList[i] = moveShiftDate + this.addPreZero(this.shiftList[index].hourList[i]) + this.addPreZero(this.shiftList[index].minuteList[i]) + '00'
          } 
        // 帰り
        } else if (this.shiftList[0].shiftBasic.shiftFlag === '1') {
          for (let m = 0; m < this.shiftList[index].hourList.length; m++) {
            this.shiftList[index].timeList[m] = moveShiftDate + this.addPreZero(this.shiftList[index].hourList[m]) + this.addPreZero(this.shiftList[index].minuteList[m]) + '00'
          }
          // this.shiftList[index].timeList[this.shiftList[index].hourList.length - 1] = moveShiftDate + this.addPreZero(this.shiftList[index].hourList[this.shiftList[index].hourList.length - 1]) + '0000'
        }
        // １つの便内で、時間の順序が逆行していないかチェック
        for (let i = 0; i < this.shiftList[index].timeList.length - 1; i++) {
          if (!(DateUtil.stringToDate(this.shiftList[index].timeList[i]) <= DateUtil.stringToDate(this.shiftList[index].timeList[i + 1]))) {
            this.$refs.stationCom[index].timeError = true
            return false
          }
        }
      }
      
      return true
    },
    // 便编辑时间顺序检验
    editorTimeCombination () {
      // 編集か増便のときここに来る
      console.log("editorTimeCombination")
      // 停留所时间校验 下面的时间必须大于上面的时间
      let stationComCount = 0
      let stationComCountTemp = 0
      for(let index = 0; index < this.shiftList.length; index++){
          stationComCount = stationComCountTemp
          if(this.shiftList[index].functionFlag === '1'){
            this.$refs.passpointCom[index].timeError = false
          }else if(this.functionFlag === '3'){
            this.$refs.shiftAddCom[index].timeError = false
          }else if(this.shiftList[index].functionFlag === '0'){
            this.$refs.stationCom[stationComCount].timeError = false
            stationComCountTemp = stationComCount + 1
          }
        // 获取当前的运行日
        let moveShiftDate = this.shiftList[0].shiftBasic.moveShiftTime
        // 行き
        if (this.shiftList[0].shiftBasic.shiftFlag === '0') {
          // item.timeList[0] = moveShiftDate + this.addPreZero(item.hourList[0]) + '0000'
          for (let i = 0; i < this.shiftList[index].hourList.length; i++) {
            this.shiftList[index].timeList[i] = moveShiftDate + this.addPreZero(this.shiftList[index].hourList[i]) + this.addPreZero(this.shiftList[index].minuteList[i]) + '00'
          } 
        // 帰り
        } else if (this.shiftList[0].shiftBasic.shiftFlag === '1') {
          for (let m = 0; m < this.shiftList[index].hourList.length; m++) {
            this.shiftList[index].timeList[m] = moveShiftDate + this.addPreZero(this.shiftList[index].hourList[m]) + this.addPreZero(this.shiftList[index].minuteList[m]) + '00'
          }
        }
        for (let i = 0; i < this.shiftList[index].timeList.length - 1; i++) {
          if (!(DateUtil.stringToDate(this.shiftList[index].timeList[i]) <= DateUtil.stringToDate(this.shiftList[index].timeList[i + 1]))) {
            // this.showMessage('便名「' + this.shiftList[index].shiftBasic.title + '」の入力時間の順序が不正です。')
            if(this.shiftList[index].functionFlag === '1'){
              this.$refs.passpointCom[index].timeError = true
            }else if(this.functionFlag === '3'){
              this.$refs.shiftAddCom[index].timeError = true
            }else if(this.shiftList[index].functionFlag === '0'){
              this.$refs.stationCom[stationComCount].timeError = true
            }
            return false
          }
        }
      }
      return true
    },
    // 数字前面补零
    addPreZero (number) {
      return number > 9 ? number.toString() : '0' + number
    },
    // 停留所時刻入力チェック
    // すべての停留所に予定時間が入力されているかチェック
    stationTimeValidate () {
      let len = 0
      let stationComCount = 0
      let stationComCountTemp = 0
      let errorFlag = false
      let errorCount = 0

      for(let i=0; i < this.shiftList.length; i++){
        stationComCount = stationComCountTemp
        errorFlag = false

        if(this.functionFlag === '0' || this.functionFlag === '2'){
          this.$refs.stationCom[i].shiftTimeError = false
        }else if(this.functionFlag === '1' && this.shiftList[i].functionFlag === '1'){
          this.$refs.passpointCom[i].shiftTimeError = false
        }else if(this.functionFlag === '1' && this.shiftList[i].functionFlag === '0'){
          this.$refs.stationCom[stationComCount].shiftTimeError = false
          stationComCountTemp = stationComCount + 1
        }else if(this.functionFlag === '3'){
          this.$refs.shiftAddCom[i].shiftTimeError = false
        }

        if(this.shiftList[i].hourList.length < this.shiftList[i].stationList.length){
          errorFlag = true
        }else{
          for(let j=0; j < this.shiftList[i].hourList.length; j++){
            if(this.shiftList[i].hourList[j] == null){
              errorFlag = true
            }
          }
        }
        if(this.shiftList[i].minuteList.length < this.shiftList[i].stationList.length){
          errorFlag = true
        }else{
          for(let j=0; j < this.shiftList[i].minuteList.length; j++){
            if(this.shiftList[i].minuteList[j] == null){
              errorFlag = true
            }
          }
        }

        if(errorFlag){
          errorCount++
          if(this.functionFlag === '0' || this.functionFlag === '2'){
            this.$refs.stationCom[i].shiftTimeError = true
          }else if(this.functionFlag === '1' && this.shiftList[i].functionFlag === '1'){
            this.$refs.passpointCom[i].shiftTimeError = true
          }else if(this.functionFlag === '1' && this.shiftList[i].functionFlag === '0'){
            this.$refs.stationCom[stationComCount].shiftTimeError = true
          }else if(this.functionFlag === '3'){
            this.$refs.shiftAddCom[i].shiftTimeError = true
          }
        }
      }

      if(errorCount > 0){
        return false
      }
    
      return true
    },
    // 適用開始日和適用終了日校验
    startEndTimeValidate () {
      // 適用終了日小于適用開始日
      if (this.endTime < this.startTime) {
        // 错误message提示
        this.showMessage('適用終了日は適用開始日後の日付を選択してください。')
        return false
      }
      this.loopDateList = this.getLoopDateList()
      for(let i=0; i < this.shiftList.length; i++){
        this.shiftList[i].loopDateList = this.loopDateList
      }
      if (this.loopDateList.length === 0) {
        // 错误message提示
        this.showMessage('<p>繰り返し登録に失敗しました。以下の要因が考えられます。</p>' +
        '<p style="text-align: left;padding-left:25%">・車両が別で使われている</p>' +
        '<p style="text-align: left;padding-left:25%">・ドライバーに別の運転予定がある</p>' +
        '<p style="text-align: left;padding-left:25%">・選択された期間とパターン設定に矛盾が生じる</p>')
        return false
      }
      return true
    },
    // 将数据传入后台
    commitServer () {
      // 去前后空字符串
      // 空白を削除
      // this.shiftBasicModel = StringUtil.trim(this.shiftBasicModel)
      for(let i = 0; i < this.shiftList.length; i++){
        this.shiftList[i].shiftBasic = StringUtil.trim(this.shiftList[i].shiftBasic)
        this.shiftList[i].shiftBasic.shiftFlag = this.shiftList[0].shiftBasic.shiftFlag
      }
      console.log("コミット直前")
      console.log(this.shiftList)
      console.log(this.shiftConnectList)
      console.log(this.shiftPasspointList)
      let parentShiftIdTemp = this.shiftList[0].shiftBasic.shiftId
      sessionStorage.setItem('routeName', JSON.stringify(this.shiftList[0].shiftBasic.routeName))
      // 編集画面の場合、便ごとに既存・新規の判定を入れる
      // 削除した既存便は削除フラグを立ててshiftListに戻してバックに投げる
      let activeShiftCount = this.shiftList.length
      if(this.functionFlag == '1'){
        for(let i=0; i < this.shiftList.length; i++){
          if(this.shiftList[i].functionFlag == '1'){
            this.shiftList[i].frontId = this.shiftList[i].shiftBasic.shiftId
          }
        }
        for(let i=0; i < this.removeShiftList.length; i++){
          this.removeShiftList[i].functionFlag = '4'
          this.shiftList.unshift(this.removeShiftList[i])
        }
        console.log("func1")
        console.log(this.shiftList)
      }
      console.log("activeShiftCount")
      console.log(activeShiftCount)
      this.$axios
        .post('shift/saveShiftInfoAndShiftConnect', {
          shiftCopeWithShiftConnectModelList: this.shiftList,
          shiftConnectModelList: activeShiftCount > 1 ? this.shiftConnectList : null,
          shiftEvent: null
        })
        .then(() => {
          if (this.functionFlag === '0' || this.functionFlag === '2') {
            // 便を登録後、一覧画面に戻る
            this.$router.push({ name: 'MovementShift' })
          } else if (this.functionFlag === '1') {
            // this.$router.push({ name: 'MovementShift' })
            this.$router.push({name: 'ShiftWithEventDetail', query: {from: 'ShiftEditor', shiftId: parentShiftIdTemp, allConnectShiftsCanEdit: 'true'}})
          } else{
            this.$router.push({ name: 'MovementShift' })
          }
          
        })
        .catch((error) => {
          if (error.data.error === 'WBE2001') {
            console.log(error.data.error_description)
            this.showMessage(error.data.error_description)
          }else{
            this.showMessage('予期せぬエラーが発生しました。')
          }
          console.log("登録時エラー")
          console.log(this.shiftList)
          console.log(this.shiftConnectList)
          console.log(error)
        })
    },
    // 前台数据提交
    submit () {
      let model = document.getElementById('modal-shift-detail-event')
      model.href = 'javascript:void(0)'

      // 0:便を登録
      if (this.functionFlag === '0' || this.functionFlag === '2') {
        if (this.routeSelected) {
          // 将出发地和终着地时间校验标志位置为true，触发子组件的校验
          this.$refs.stationCom[0].triggerValidate()
          this.$refs.stationCom[0].$validator.validateAll()
        }
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$refs.stationCom[0].$validator.validateAll().then(result => {
              if (result) {
                // 停留所时间校验
                if (this.stationTimeValidate()) {
                  // hour minute 时间拼接
                  if (this.timeCombination()) {
                    // 驾驶员验证
                    if (this.shiftDriverValidate()) {
                    // 车辆验证
                      if (this.vehicleValidate()) {
                        if (this.shiftVehiclValidate()) {
                          console.log("shiftVehiclValidate ok")
                          // 接続確認
                          let connectCheck = false
                          if(this.shiftList.length > 1){
                            connectCheck = this.shiftConnectValidate()
                          }else{
                            connectCheck = true
                          }
                          if(connectCheck){
                            // 便経由地情報集合赋值
                            this.getShiftPasspointList()
                            if (this.loopUseCheckbox) {
                              if (this.startEndTimeValidate()) {
                                model.href = '#modal-container-shift-detail-event'
                                this.$refs.shiftInfoDialog
                                  .confirm()
                                  .then(() => {
                                  // 将数据传到后台
                                    this.commitServer()
                                  }
                                  )
                              }
                            } else {
                              model.href = '#modal-container-shift-detail-event'
                              this.$refs.shiftInfoDialog
                                .confirm()
                                .then(() => {
                                // 将数据传到后台
                                  this.commitServer()
                                }
                                )
                            }
                          }
                        } else {
                        // 车辆选择不正确的场合，将其置为空
                          this.shiftBasicModel.vehicleId = ''
                        }
                      // })
                      } else {
                      // 车辆选择不正确的场合，将其置为空
                        this.shiftBasicModel.vehicleId = ''
                      }
                    } else {
                      // driver选择不正确的场合，将其置为空
                      this.shiftBasicModel.driverUid = ''
                      this.shiftBasicModel.driverKanaName = ''
                    }
                  }
                }else{
                  console.log(this.stationTimeMessage)
                }
              }
            })
          }

        })
      } else if (this.functionFlag === '1') {
        // 1:便を編集passpointCom
        console.log("submit 1:便を編集")
        // 将出发地和终着地时间校验标志位置为true，触发子组件的校验
        this.$refs.passpointCom[0].triggerValidate()
        this.$validator.validateAll().then(
          result => {
            if (result) {
              this.$refs.passpointCom[0].$validator.validateAll().then(result => {
                if (result) {
                  // 停留所时间校验
                  if (this.stationTimeValidate()) {
                    console.log("stationTimeValidate OK")
                    // 时间大小顺序校验
                    if (this.editorTimeCombination()) {
                      console.log("editorTimeCombination OK")

                      for(let i = 0; i < this.shiftList.length; i++){
                        if(this.shiftList[i].functionFlag == '1'){
                          this.$refs.passpointCom[i].savePasspoints(this.shiftList[i].shiftBasic.moveShiftTime, i)
                        }
                      }
                      // 驾驶员验证
                      if (this.shiftDriverValidate() && this.editorShiftDriverValidate()) {
                        console.log("shiftDriverValidate OK")
                        if (this.vehicleValidate()) {
                         console.log("vehicleValidate OK")

                          let editorShiftTimeInfoList = this.shiftTimeInfoList.filter((item) => item.shiftId !== this.shiftBasicModel.shiftId)
                          if (this.editorShiftVehiclValidate(editorShiftTimeInfoList)) {
                            console.log("editorShiftVehiclValidate OK")

                            let connectCheck = false
                            console.log("connectCheck")
                            if(this.shiftList.length > 1){
                              connectCheck = this.shiftConnectValidate()
                                // すべての便に区域内便の日付を割り当て
                              for(let i = 1; i < this.shiftList.length; i++){
                                this.shiftList[i].shiftBasic.moveShiftTime = this.shiftList[0].shiftBasic.moveShiftTime
                              }
                            }else{
                              connectCheck = true
                            }
                            if(connectCheck){
                              this.getShiftPasspointList()
                              // 校验通过，保存更改到后台
                              model.href = '#modal-container-shift-detail-event'
                              this.$refs.shiftInfoDialog
                                .confirm()
                                .then(() => {
                                // 将数据传到后台
                                  this.commitServer()
                                }
                                )
                            }
                          } else {
                            // 车辆选择不正确的场合，将其置为空
                            this.shiftBasicModel.vehicleId = ''
                          }
                        } else {
                          // 车辆选择不正确的场合，将其置为空
                          this.shiftBasicModel.vehicleId = ''
                        }
                      } else {
                      // driver选择不正确的场合，将其置为空
                        this.shiftBasicModel.driverUid = ''
                        this.shiftBasicModel.driverKanaName = ''
                      }
                    }
                  }else{
                    console.log(this.stationTimeMessage)
                  }
                }
              })
            }
          })
      } else {
        if (this.functionFlag === '3') {
          // 2:便を登録(增便)
          console.log("validate function3")
          this.$validator.validateAll().then(
            result => {
              if (result) {
                this.$refs.shiftAddCom[0].$validator.validateAll().then(result => {
                  if (result) {
                    this.$refs.shiftAddCom[0].savePasspoints(this.shiftList[0].shiftBasic.moveShiftTime)
                    // 停留所时间校验
                    if (this.stationTimeValidate()) {
                      console.log("stationTimeValidate ok")
                      // 时间大小顺序校验
                      if (this.editorTimeCombination()) {
                        console.log("editorTimeCombination ok")
                        this.$refs.shiftAddCom[0].savePasspoints(this.shiftList[0].shiftBasic.moveShiftTime)

                        // 驾驶员验证
                        if (this.shiftDriverValidate()) {
                        console.log("editorShiftDriverValidate ok")
                          if (this.vehicleValidate()) {
                            console.log("vehicleValidate ok")
                            if (this.shiftVehiclValidate()) {
                              console.log("shiftVehiclValidate ok")
                              console.log("this.shiftList[0].shiftPasspointList")
                              console.log(this.shiftList[0].shiftPasspointList)
                              for (let i = 0; i < this.shiftList[0].shiftPasspointList.length; i++) {
                                this.shiftList[0].shiftPasspointList[i].startPassengers = this.shiftList[0].shiftPasspointList[i].arrivePassengers
                              }
                              console.log("commit function3")
                              console.log(this.shiftList)
                              this.shiftList.splice(0,this.shiftList)
                              model.href = '#modal-container-shift-detail-event'
                              this.$refs.shiftInfoDialog
                                .confirm()
                                .then(() => {
                                // 将数据传到后台
                                  this.commitServer()
                                }
                                )
                            } else {
                            // 车辆选择不正确的场合，将其置为空
                              this.shiftList[0].shiftBasic.vehicleId = ''
                            }
                          } else {
                          // 车辆选择不正确的场合，将其置为空
                            this.shiftList[0].shiftBasic.vehicleId = ''
                          }
                        } else {
                          // driver选择不正确的场合，将其置为空
                          this.shiftList[0].shiftBasic.driverUid = ''
                          this.shiftList[0].shiftBasic.driverName = ''
                          this.shiftList[0].shiftBasic.driverKanaName = ''
                        }
                      }
                    }else{
                      console.log(this.stationTimeMessage)
                      // this.showMessage(this.stationTimeMessage)
                    }
                  }
                })
              }
            })
        }
      }

      window.setTimeout( this.makeErrorList, 1 );
       
    },
    yearWeek (day) {
      return DateUtil.yearWeek(day)
    },
    // 便追加ボタン
    addShift () {
      // コンポーネント呼び出し切り替え 編集画面で一度便追加ボタンを押した後は新規作成画面と同じコンポーネントを呼び出す
      // this.addShiftFlag = true
      // 便リスト追加
      this.shiftList.push(
        {
        frontId: this.ShiftFrontIdCount.toString(),
        shiftEvent: null,
        // shiftBasicModel
        shiftBasic: {
            // 便Id(重新生成)
            shiftId: '',
            // 便名称（update）
            title: '',
            // ルートID
            routeId: '',
            // ルートName
            routeName: '',
            // ドライバーUID  （update）
            driverUid: '',
            // 車両ID  （update）
            vehicleId: '',
            // 運行日
            moveShiftTime: '',
            // 行帰フラグ
            shiftFlag: '0',
            // 出発予定時台  (对应shiftFlag: '0'  ？？？？？？写下面还是上面)
            startEstimateTimeSlot: '',
            // 到着予定時台 (对应shiftFlag: '1'  ？？？？？？？)
            arriveEstimateTimeSlot: '',
            // 利用料金  （update）
            shiftCost: 0,
            // イベントID
            eventId: '',
            // フリガナ
            driverKanaName: '',
            // ドライバー
            driverName: '',
            // 車両？？？？
            vehicleName: '',
            // 車両定員人数？？？？
            passengerNumber: '',
            // 便タイプ
            shiftType: '1',
            // 公開フラグ
            openFlag: 0,
            // 地区ID
            areaId: '',
            // 地区名
            areaName: '',
            // 交通事業者区分
            transportKind: '',
            // 親便ID
            parentShiftId: '',
            // 元便ID
            oldShiftId: '',
            // 予約人数
            reserveNumber: 0,
            // 運行状態
            shiftMovementStatus: 3,
            businessStatus: 3,
            // コメント
            comment: '',
        },
        // shiftPasspoint
        shiftPasspointList: [{
          shiftId: '0000',
          routeId: '',
          sortNo: '',
          routeType: '',
          stationId: '',
          reserveId: '',
          startEstimateTime: '',
          arriveEstimateTime: '',
          arriveActualTime: '',
          updateUser: '',
        }],
        functionFlag: '0',
        // shiftReservationInfos
        shiftReservationInfoList: [],
        // 時刻リスト
        hourList: [],
        minuteList: [],
        timeList: [],
        loopDateList: null,
        // ドライバー情報
        shiftTimeInfoListByDriverUid: [],
        // 車両情報
        selectedVehicle: [],
        // ドライバーアプリ使用有無 1:ドライバーアプリ使用 2:未使用
        routeType: '',
        // ルート選択フラグ
        routeSelected: false,
        // 停留所一覧
        stationList: [{
          routeId: '',
          routeName: '',
                    }
        ]
        })
      this.ShiftFrontIdCount++
      //接続エリア更新
      this.setShiftConnectStationList()
      if(this.shiftList.length > 0 && this.shiftConnectList.length == 0){
        this.addConnect()
      }
    },
    // 接続追加ボタン
    addConnect(){
      console.log("addConnect")
      this.shiftConnectList.push(
        {
        frontShiftConnect: {
          shiftId: '0000',
          connectSourceShiftId: '0000',
          stationId: '',
          connectSourceStationId: '',
          stationTime: '',
          connectSourceStationTime: '',
          stationUseTime: 0,
          errorMessage: '',
          timeError: 0
        },
        shiftConnect: {
          shiftId: '',
          connectSourceShiftId: '',
          stationId: '',
          connectSourceStationId: '',
          stationUseTime: 0
        },
      })
      this.setShiftConnectStationList()
      console.log(this.shiftConnectList)
    },
    // 便削除ボタン
    delShift (index) {
      if (this.shiftList.length > 1) {
        this.removeShiftList.push(this.shiftList[index])
        this.shiftList.splice(index, 1)
        this.ShiftFrontIdCount--

        if(this.shiftList.length == 1){
          this.shiftConnectList.length = 0
        }
      }
    },
    // 接続削除ボタン
    delConnect (index) {
      // 经由地数组长度大于0
      if (this.shiftConnectList.length > 1) {
        this.shiftConnectList.splice(index, 1)

        //接続エリア更新
        // this.setShiftConnectStationList()
        this.chooseConnect() 
      }
    },
    debugCall(){
      console.log("// ---------------------------------------------------------------------------------------------- //")
      console.log("this.shiftList")
      console.log(this.shiftList)
      console.log("this.shiftConnectList")
      console.log(this.shiftConnectList)
      console.log("this.routeInfo")
      console.log(this.routeInfo)
      console.log("this.selectedRouteStationInfo")
      console.log(this.selectedRouteStationInfo)
      console.log('this.connectGroupList')
      console.log(this.connectGroupList)
      console.log("isLoading")
      console.log(this.isLoading)

      console.log(this.shiftList[0].shiftBasic.shiftId)
      this.$axios.get('shift/queryShiftConnectList', {params: {parentId: this.shiftList[0].shiftBasic.shiftId}}).then(response => {
        console.log(response.data)
      console.log("// ---------------------------------------------------------------------------------------------- //")
      })
    },
    // 获取08：40的日期格式
    getHourMin (dateStr) {
      if (dateStr === null || dateStr === '') {
        return ''
      }
      return dateStr.substr(8, 2) + '時' + dateStr.substr(10, 2)+ '分 '
    },

    updateShiftList (updateShiftList, index){
      this.shiftList[index].stationList = updateShiftList
    },

    setShiftConnect(){
      console.log("setShiftConnect")
      for(let connectIndex = 0; connectIndex < this.shiftConnectList.length; connectIndex++){
        for(let shiftIndex = 0; shiftIndex<this.shiftList.length; shiftIndex++){
          if(this.shiftList[shiftIndex].shiftBasic.shiftId == this.shiftConnectList[connectIndex].frontShiftConnect.connectSourceShiftId){
              this.shiftConnectList[connectIndex].frontShiftConnect.connectSourceStationList = this.shiftList[shiftIndex].stationList
          }else if(this.shiftList[shiftIndex].shiftBasic.shiftId == this.shiftConnectList[connectIndex].frontShiftConnect.shiftId){
              this.shiftConnectList[connectIndex].frontShiftConnect.stationList = this.shiftList[shiftIndex].stationList
          }
        }
      }
    },
    // ページ内スクロール
    scrollToAnchorPoint(id) {
      // const el = this.$refs[refName]
      let el = document.getElementById(id)
      el.scrollIntoView({ behavior: 'smooth'})
    },
    // 接続設定をリセット
    clearShiftConnect(shiftId = ''){
      console.log("clearShiftConnect shiftId = " + shiftId)
      if(shiftId == ''){
        this.shiftConnectList = [{
          frontShiftConnect: {
            shiftId: '',
            connectSourceShiftId: '',
            stationId: '',
            connectSourceStationId: '',
            stationTime: '',
            connectSourceStationTime: '',
            stationUseTime: 0,
            errorMessage: '',
            timeError: 0
          },
          shiftConnect: {
            shiftId: '',
            connectSourceShiftId: '',
            stationId: '',
            connectSourceStationId: '',
            stationUseTime: 0
          }
        }]
      }else{
        for(let i = 0; i < this.shiftList.length; i++){
          if(this.shiftList[i].functionFlag == 0){
            if(this.shiftList[i].frontId == shiftId){
              this.shiftList[i].hourList = []
              this.shiftList[i].minuteList = []
              this.shiftList[i].timeList = []
            }
          }else{
            if(this.shiftList[i].shiftBasic.shiftId == shiftId){
              this.shiftList[i].hourList = []
              this.shiftList[i].minuteList = []
              this.shiftList[i].timeList = []
            }
          }
        }
        for(let i = 0; i < this.shiftConnectList.length; i++){
          if(this.shiftConnectList[i].frontShiftConnect.shiftId == shiftId){
            this.shiftConnectList[i].frontShiftConnect.shiftId = ''
            this.shiftConnectList[i].frontShiftConnect.stationId = ''
            this.shiftConnectList[i].frontShiftConnect.stationTime = ''
          }
          if(this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId == shiftId){
            this.shiftConnectList[i].frontShiftConnect.connectSourceShiftId = ''
            this.shiftConnectList[i].frontShiftConnect.connectSourceStationId = ''
            this.shiftConnectList[i].frontShiftConnect.connectSourceStationTime = ''
          }
        }
      }
      // 描画をリセット
      this.shiftConnectList.splice(0,this.shiftConnectList)
    }
  }
}
</script>

<template>
  <div class="col-md-12 column" id="shiftInfoSpace" style="width:100%;display:flex;flex-direction: column;flex:1">
    <div class="row clearfix" style="flex: 0 0 40px">
      <div class="col-md-12 column">
        <div class="row clearfix">
          <div class="col-md-12 column T7-title" @click="debugCall">
          {{title}}
          </div>
        </div>
        <div class="row clearfix">
          <div class="col-md-3 column clearfix" style="min-width: 320px;margin-left: 2.5%">
          <span class="F3-R-14">※必須項目</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row clearfix slider" style="flex: 1;display:flex;">
      <div style="flex: 0 0 180px">
      </div>
      <div style="flex: 1; height: 65vh;">
        <!-- 追加ボタン対応エリア -->
        <div class="shiftItem" :id='`shiftItem${index}`' v-for="(item, index) in shiftList" :key="index">
          <div class="shiftItemBar"></div>
          <div class="shiftItemFlex">
            <!-- アコーディオン展開ボタン -->
            <input type="checkbox" :id='`shiftItemCheck${index}`'>
            <label :for='`shiftItemCheck${index}`'>
              <div class="shiftItemView">
                ▼
              </div>
            </label>
            <!-- 入力フォーム -->
            <div class="shiftItemMain">
              <!-- 運行区分 -->
              <div class="clearfix shiftViewHead">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-12 column clearfix">
                      運行区分
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column">
                    <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix">
                      <span v-if="index==0">区域内</span>
                      <span v-else>区域外</span>
                    </div>
                </div>
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-12 column clearfix">
                      ドライバーアプリ端末
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column">
                    <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix">
                      <span v-show="(item.routeType === '0')||(item.routeType === '1')">使用する</span>
                      <span v-show="item.routeType === '2'">使用しない</span>
                    </div>
                </div>
              </div>
              <!-- 便名 -->
              <div class="clearfix divMarginTop shiftViewHead">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-4 column clearfix textAlignLeft">
                      ※
                    </div>
                    <div class="col-md-8 column clearfix textAlignLeft">
                      便名
                    </div>
                  </div>
                </div>
                <div class="col-md-10 column">
                    <input
                      type="text"
                      :name='`shiftName${index}`'
                      v-validate="'required|paintWordNo'"
                      v-model="item.shiftBasic.title"
                      maxlength="50"
                      class="inputstyles F3-R-20"/>
                </div>
              </div>
              <!-- 便名エラー -->
              <div class="clearfix">
                <div class="col-md-2 column shortDiv">
                </div>
                <div class="col-md-10 column textAlignLeft">
                  <span v-if="errors.has('shiftName' + index)" class="errorMessage"> {{ errors.first('shiftName' + index) }} </span>
                </div>
              </div>
              <!-- 便ID -->
              <div class="clearfix divMarginTop" v-if="functionFlag==='1'">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-12 column clearfix">
                      便<span> ID</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column shortInput">
                  <div class="divTitle longsolid F3-R-20 bgc5">{{item.shiftBasic.shiftId}}</div>
                </div>
              </div>
              <!-- ルート -->
              <div class="clearfix divMarginTop">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-4 column clearfix textAlignLeft">
                      <span v-if="functionFlag==='0'||(functionFlag==='1'&& item.shiftBasic.reserveNumber===0)||(functionFlag==='2'&&index != 0)">※</span>
                    </div>
                  <div class="col-md-8 column clearfix textAlignLeft" style="padding-left: 8px">
                      ルート
                  </div>
                  </div>
                </div>
                <div v-if="functionFlag==='0'||(functionFlag==='1' && item.shiftBasic.reserveNumber===0 && !lockedByReserve)||(functionFlag==='2'&&index != 0)">
                <div class="col-md-8 column" style="width:69%">
                  <!-- 区域内用 -->
                  <select class="selectstyles selectImg F3-R-20" :name='`selectRoute${index}`'
                  v-validate="{required: functionFlag==='0'||functionFlag==='1'||(functionFlag==='2'&&index != 0)}"
                  v-model="item.shiftBasic.routeId"
                  v-if="index==0"
                  @change="clearShiftConnect(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId), chooseRoute(item.shiftBasic.routeId, index)">
                    <option :value="route.routeId" :key="index"  v-for="(route, index) in routeInfo" v-show="route.transportKind == 0">
                      {{route.routeName}}
                    </option>
                  </select>
                  <!-- 区域外用 -->
                  <select class="selectstyles selectImg F3-R-20" :name='`selectRoute${index}`'
                  v-validate="{required: functionFlag==='0'||functionFlag==='1'||(functionFlag==='2'&&index != 0)}"
                  v-model="item.shiftBasic.routeId"
                  v-else
                  @change="clearShiftConnect(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId), chooseRoute(item.shiftBasic.routeId, index)">
                    <option :value="route.routeId" :key="index"  v-for="(route, index) in routeInfo" v-show="route.transportKind == 1">
                      {{route.routeName}}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 column shortDiv paddingLeftZero paddingRightZero">
                    <!-- 便追加によりどの便のルートを表示するか決定するためchooseRouteを介すように変更 -->
                    <button @click="chooseRoute(item.shiftBasic.routeId, index, true)" class="T7-radius F2-R-19" :href="hrefFlag ? '#routeInfoWindow': 'javascript:void(0)'" style="cursor:pointer;" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                    ルートを確認
                    </button>
                  <!-- </a> -->
                </div>
                </div>
                <div v-else class="col-md-10 column">
                    <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix">{{item.shiftBasic.routeName}}</div>
                </div>
              </div>
              <!-- ルートエラー文 -->
              <div class="clearfix">
                <div class="col-md-2 column shortDiv">
                </div>
                <div class="col-md-10 column textAlignLeft">
                <span v-if="errors.has('selectRoute' + index)" class="errorMessage"> {{ errors.first('selectRoute' + index) }} </span>
                </div>
              </div>
              <!-- 行き帰りラジオボタン -->
              <div class="clearfix divMarginTop">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-4 column clearfix textAlignLeft">
                      <span v-if="functionFlag==='0'||(functionFlag==='1'&& item.shiftBasic.reserveNumber===0)||functionFlag==='2'">※</span>
                    </div>
                    <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                      行き/帰り
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column shortInput" v-if="functionFlag==='3' || (functionFlag==='1' && item.shiftBasic.reserveNumber>0)">
                  <div class="divTitle longsolid F3-R-20 bgc5" >{{item.shiftBasic.shiftFlag==='0'?'行き':'帰り'}}</div>
                </div>
                <div class=" col-md-4 radiodiv textAlignLeft stationWidth" v-else>
                  <div v-if="index==0">
                    <label class="radio-inline F3-R-20" style="margin-right: 4%">
                      <input @change="clearShiftConnect()" class="radiobutton" type="radio" v-model="item.shiftBasic.shiftFlag" value="0"><span></span>行き
                    </label>
                    <label class="radio-inline F3-R-20" >
                      <input @change="clearShiftConnect()" class="radiobutton" type="radio" v-model="item.shiftBasic.shiftFlag" value="1"><span></span>帰り
                    </label>
                  </div>
                  <div v-else>
                    <input  class="radiobutton" type="radio" v-model="item.shiftBasic.shiftFlag" :value="shiftList[0].shiftBasic.shiftFlag" v-show="false">
                    <div class="divTitle longsolid F3-R-20 bgc5" >{{shiftList[0].shiftBasic.shiftFlag==='0'?'行き':'帰り'}}</div>
                  </div>
                </div>
              </div>
              <!-- 地区フィルター -->
              <div class="clearfix divMarginTop" v-if="index==0">
                <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-12 column clearfix">
                      地区フィルター
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column shortInput">
                <select class="selectstyles selectImg F3-R-20" name="selectArea" v-model="item.shiftBasic.areaId"
                  @change="chooseArea(item.shiftBasic.areaId, index)" v-if="(functionFlag!=='3' && functionFlag!=='1') || (functionFlag==='1' && item.shiftBasic.reserveNumber===0)">
                  <option value=""></option>
                  <option :value="area.codeValue" :key="index"  v-for="(area, index) in areaInfo">
                    {{area.codeName}}
                  </option>
                </select>
                <div v-else class="divTitle longsolid F3-R-20 bgc5">{{item.shiftBasic.areaName}}</div>
                </div>

              </div>
              <!-- 運行日 -->
              <div class="clearfix divMarginTop">
                <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-4 column clearfix textAlignLeft">
                      <span v-if="(functionFlag!=='3' && functionFlag!=='1') || (functionFlag==='1' && item.shiftBasic.reserveNumber===0)">※</span>
                    </div>
                    <div class="col-md-8 column clearfix textAlignLeft"  style="padding-left: 8px">
                      運行日
                    </div>
                  </div>
                </div>
                <div class="col-md-4 column shortInput">
                  <div v-if="(functionFlag!=='3' && functionFlag!=='1') || (functionFlag==='1' && item.shiftBasic.reserveNumber===0)">
                    <calendar-input v-if="index==0" @getValue="getMoveShiftTime"
                      :need-weeks=true
                      :input-style="'height: 50px;font-size: 16px;padding-left:12px'"
                      :selectY="moveShiftTimeYear"
                      :selectM="moveShiftTimeMonth"
                      :selectD="moveShiftTimeDay"></calendar-input>
                    <div v-else class="divTitle longsolid F3-R-20 bgc5" style="margin-bottom:5px">
                      <input type="radio" v-show="false" v-model="item.shiftBasic.moveShiftTime" :value="shiftList[0].shiftBasic.moveShiftTime">
                      {{yearWeek(shiftList[0].shiftBasic.moveShiftTime)}}
                    </div>
                  </div>
                  <div v-else>
                    <div class="divTitle longsolid F3-R-20 bgc5" style="margin-bottom:5px">{{yearWeek(item.shiftBasic.moveShiftTime)}}</div>
                  </div>
                </div>
              </div>
              <!-- コンポーネント -->
              <div class="clearfix">
              <StationInfoComponent  v-if="(item.routeSelected&&functionFlag==='0')||functionFlag==='2'||(functionFlag==='1'&&item.functionFlag==='0')" ref="stationCom"
              :goBackFlag=shiftList[0].shiftBasic.shiftFlag
              :routeId=item.shiftBasic.routeId
              :transportKind=item.shiftBasic.transportKind
              :functionFlag=functionFlag
              :shiftIndex=index
              @getSelectedRouteStationInfo="getSelectedRouteStationInfoList"
              @getHour="getHourList"
              @getMinute="getMinuteList"></StationInfoComponent>
              <PassPointInfoComponent v-if="(functionFlag==='1'&&item.functionFlag==='1')"  ref="passpointCom"
              :goBackFlag=shiftList[0].shiftBasic.shiftFlag
              :reserveNumber=item.shiftBasic.reserveNumber
              :routeId=item.shiftBasic.routeId
              :transportKind=item.shiftBasic.transportKind
              :shiftIndex=index
              :shiftId =item.shiftBasic.shiftId
              @getSelectedRouteStationInfo="getSelectedRouteStationInfoList"
              @editorShiftPasspoints='getEditorShiftPasspoints'
              @getHour="getHourList"
              @getMinute="getMinuteList"
              @updateShiftList="updateShiftList"></PassPointInfoComponent>
                <ShiftAddComponent v-if="functionFlag==='3'"  ref="shiftAddCom"
              :goBackFlag=item.shiftBasic.shiftFlag
              @editorShiftPasspoints='getEditorShiftPasspoints'
              @getHour="getHourList"
              @getMinute="getMinuteList"></ShiftAddComponent>
              </div>
            <div :class="{floatStyle:(item.routeSelected&&functionFlag==='0')||(item.functionFlag != 0 && functionFlag!=='0')} " >
              <!-- 左寄せ -->
              <div style="width:58.33%">
                <!-- 利用料金 区域内のみ-->
                <div class="clearfix" style="margin-top:5px;" v-if="index==0">
                      <div class="col-md-3 column divTitle shortDiv belowLeftWidth bgc8 F3-R-15">
                        <div class="row clearfix">
                          <div class="col-md-4 column clearfix textAlignLeft">
                            ※
                          </div>
                          <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                            利用料金
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 column paddingRightZero" style="width:25%">
                          <input
                            type="text"
                            :name='`shiftCost${index}`'
                            v-validate="'required|numeric'"
                            v-model="item.shiftBasic.shiftCost"
                            maxlength="9"
                            class="inputstyles F3-R-20"/>
                      </div>
                      <div class="col-md-1 column hourMinute aloneWordDiv F3-R-20" style="height:25px;margin-top:25px">
                        円
                      </div>
                </div>
                <!-- 利用料金エラー文 区域内のみ-->
                <div class="clearfix" v-if="index==0">
                  <div class="col-md-3 column shortDiv belowLeftWidth">
                  </div>
                  <div class="col-md-9 column textAlignLeft">
                  <span v-if="errors.has('shiftCost' + index)" class="errorMessage"> {{ errors.first('shiftCost' + index) }} </span>
                  </div>
                </div>
                <!-- ドライバーふりがな -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column divTitle shortDiv belowLeftWidth bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-4 column clearfix">
                      </div>
                      <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero">
                        フリガナ
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column shortInput belowRightWidth">
                    <div class="divTitle longsolid F3-R-20 bgc5 overflow-fix">{{item.shiftBasic.driverKanaName}}</div>
                  </div>
                </div>
                <!-- ドライバー -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column divTitle shortDiv belowLeftWidth bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-4 column clearfix textAlignLeft">
                        <!-- <span v-if="functionFlag==='3'">※</span> -->
                      </div>
                      <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero" style="margin-left:-4px">
                        ドライバー
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column shortInput belowRightWidth">
                    <!-- 区域内用 -->
                    <select class="selectstyles selectImg F3-R-20"
                    :name='`selectDriver${index}`'
                    v-model="item.shiftBasic.driverUid"
                    v-if="index==0"
                    @change="chooseDriver(item.shiftBasic.driverUid, index)">
                      <option :value="driver.uid" :key="index"  v-for="(driver, index) in driverInfo" v-show="driver.roleFlag.substring(1, 2) === '1'">
                        {{driver.lastName}}&nbsp;{{driver.firstName}}
                      </option>
                    </select>
                    <!-- 区域外用 -->
                    <select class="selectstyles selectImg F3-R-20"
                    :name='`selectDriver${index}`'
                    v-model="item.shiftBasic.driverUid"
                    v-else
                    @change="chooseDriver(item.shiftBasic.driverUid, index)">
                      <option :value="driver.uid" :key="index"  v-for="(driver, index) in driverInfo" v-show="driver.roleFlag.substring(4, 5) === '1'">
                        {{driver.lastName}}&nbsp;{{driver.firstName}}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- ドライバーエラー文 -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv belowLeftWidth">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('selectDriver' + index)" class="errorMessage"> {{ errors.first('selectDriver' + index) }} </span>
                  <!-- ドライバー予定重複 -->
                  <span v-if="item.driverError == true" class="errorMessage"> {{ driverMessage }} </span>
                  <!-- ドライバー二重使用 -->
                  <span v-if="item.driverError2 == true" class="errorMessage"> {{ driverMessage2 }} </span>
                  </div>
                </div>
                <!-- 車両 -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column shortDiv divTitle belowLeftWidth bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-4 column clearfix textAlignLeft">
                        ※
                      </div>
                      <div class="col-md-8 column clearfix textAlignLeft">
                        車両
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column shortInput belowRightWidth">
                    <!-- 区域内用 -->
                    <select class="selectstyles selectImg F3-R-20"
                    :name='`selectVehicle${index}`'
                    v-validate="{required: true}"
                    v-model="item.shiftBasic.vehicleId"
                    v-if="index==0"
                    @change="chooseVehicle(item)">
                    <option :value="vehicle.vehicleId" :key="index"  v-for="(vehicle, index) in vehicleInfo" v-show="vehicle.transportKind==0">
                      {{vehicle.vehicleName}}&nbsp;&nbsp;&nbsp;&nbsp;{{"ID:"+vehicle.displayVehicleId}}&nbsp;&nbsp;&nbsp;&nbsp;
                      {{"定員"+vehicle.passengerNumber+"名"}}
                    </option>
                    <!-- 区域外用 -->
                    </select>
                    <select class="selectstyles selectImg F3-R-20"
                    :name='`selectVehicle${index}`'
                    v-validate="{required: true}"
                    v-model="item.shiftBasic.vehicleId"
                    v-else
                    @change="chooseVehicle(item)">
                    <option :value="vehicle.vehicleId" :key="index"  v-for="(vehicle, index) in vehicleInfo" v-show="vehicle.transportKind==1">
                      {{vehicle.vehicleName}}&nbsp;&nbsp;&nbsp;&nbsp;{{"ID:"+vehicle.displayVehicleId}}&nbsp;&nbsp;&nbsp;&nbsp;
                      {{"定員"+vehicle.passengerNumber+"名"}}
                    </option>
                    </select>
                  </div>
                </div>
                <!-- 車両エラー文 -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv belowLeftWidth">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('selectVehicle' + index)" class="errorMessage"> {{ errors.first('selectVehicle' + index) }} </span>
                  <!-- 車両ブロック -->
                  <span v-if="item.vehicleError == true" class="errorMessage"> {{ vehicleMessage }} </span>
                  <!-- 車両二重使用 -->
                  <span v-if="item.vehicleError2 == true" class="errorMessage"> {{ vehicleMessage2 }} </span>
                  <!-- 車両とドライバーの事業者が不一致 -->
                  <span v-if="item.vehicleError3 == true" class="errorMessage"> {{ vehicleMessage3 }} </span>
                  </div>
                </div>
              </div>
              <!-- コメント -->
              <div class="clearfix divMarginTop shiftViewHead">
                <div class="col-md-2 column divTitle shortDiv bgc8 F3-R-15">
                  <div class="row clearfix">
                    <div class="col-md-4 column clearfix textAlignLeft">
                      
                    </div>
                    <div class="col-md-8 column clearfix textAlignLeft paddingLeftZero" style="margin-left:-4px">
                      コメント
                    </div>
                  </div>
                </div>
                <div class="col-md-10 column">
                    <input
                      type="text"
                      v-model="item.shiftBasic.comment"
                      maxlength="50"
                      class="inputstyles F3-R-20"/>
                </div>
              </div>
            </div>
            </div>
            <!-- 便削除ボタン -->
            <div v-if="index!=0 && !lockedByReserve" class="shiftItemRemove" @click="delShift(index)">
              －
            </div>
            <div v-else class="shiftItemRemove">
            </div>
          </div>
        </div>
        <!-- 便追加ボタン -->
        <div class="shiftAddArea" v-if="!lockedByAddShift&&!lockedByReserve&&functionFlag!='3'">
          <div class="shiftAddBar">
          </div>
          <div class='bodyContext add'>
              <div @click="addShift">
                <!-- 圆圈 -->
                <div class='addIcon bgc6' style="cursor:pointer">
                  <div style="font-size:2em;color:#fff">+</div>
                </div>
                <!-- 字体 -->
                <div class='addFontSize' style="cursor:pointer">
                  <div><p style="margin:auto 0;letter-spacing:5px;font-weight: 600; color:#707070">他交通事業者の便を追加</p></div>
                </div>
              </div>
          </div>
        </div>
        <!-- 乗り継ぎ接続設定エリア -->
        <div v-if="shiftList.length > 1">
          <div class="connectItem" v-for="(connect,index) in shiftConnectList" :key="index" :id='`connectItem${index}`'>
            <div class="connectItemBar"></div>
            <div class="connectItemFlex">
              <div class="connectItemMain">
                <div class="connectItemTitle">
                  乗り継ぎ接続設定{{index + 1}}
                </div>
                <!-- 接続元運行便 -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-12 column clearfix">
                        接続元運行便
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column connectSelectLong">
                    <!-- 行き用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.connectSourceShiftId" v-if="shiftList[0].shiftBasic.shiftFlag == 0"
                      :name='`connectSourceShift${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="setShiftConnectStationList(1), chooseConnect()">
                      <option v-for="(item,index) in shiftList" :key="index" :value="(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId)">{{item.shiftBasic.title}}</option>
                    </select>
                    <!-- 帰り用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.shiftId" v-else
                      :name='`connectSourceShift${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="setShiftConnectStationList(2), chooseConnect()">
                      <option v-for="(item,index) in shiftList" :key="index" :value="(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId)">{{item.shiftBasic.title}}</option>
                    </select>
                  </div>
                </div>
                <!-- 接続元運行便エラー -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('connectSourceShift' + index)" class="errorMessage"> {{ errors.first('connectSourceShift' + index) }} </span>
                  </div>
                </div>
                <!-- 接続元停留所 -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-12 column clearfix">
                        接続元停留所
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column shortInput">
                    <!-- 行き用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.connectSourceStationId" @change="chooseConnect()" v-if="shiftList[0].shiftBasic.shiftFlag == 0"
                      :name='`connectSourceStation${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve">
                      <!-- <option v-for="(station,index) in shiftList[parseInt(connect.frontShiftConnect.connectSourceShiftId)].stationList" :key="index" :value="station.stationId">{{station.stationName}}</option> -->
                      <option v-for="(station,index) in connect.frontShiftConnect.connectSourceStationList" :key="index" :value="station.stationId"
                      v-if="station.officeFlag != 1 && station.canStart != false"
                      >{{station.stationName}}</option>
                    </select>
                    <!-- 帰り用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.stationId" @change="chooseConnect()" v-else
                      :name='`station${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve">
                      <!-- <option v-for="(station,index) in shiftList[parseInt(connect.frontShiftConnect.shiftId)].stationList" :key="index" :value="station.stationId">{{station.stationName}}</option> -->
                      <option v-for="(station,index) in connect.frontShiftConnect.stationList" :key="index" :value="station.stationId"
                      v-if="station.officeFlag != 1 && station.canStart != false">{{station.stationName}}</option>
                    </select>
                  </div>
                  <div class="col-md-4 column divTitle bgc8 connectItemTime">
                    <div class="row clearfix">
                      <div class="column clearfix" :class="{connectTimeError:connect.frontShiftConnect.timeError == 1}">
                        {{getHourMin(shiftList[0].shiftBasic.shiftFlag == 0 ? connect.frontShiftConnect.connectSourceStationTime:connect.frontShiftConnect.stationTime)}}着
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 接続元停留所エラー -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('connectSourceStation' + index)" class="errorMessage"> {{ errors.first('connectSourceStation' + index) }} </span>
                  <span v-if="connect.frontShiftConnect.timeError == 1" class="errorMessage"> 停留所あるいは便情報の時刻を修正してください。 </span>
                  </div>
                </div>
                <!-- 接続先運行便 -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-12 column clearfix">
                        接続先運行便
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column connectSelectLong">
                    <!-- 行き用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.shiftId" v-if="shiftList[0].shiftBasic.shiftFlag == 0"
                      :name='`connectShift${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="setShiftConnectStationList(2), chooseConnect()">
                      <option v-for="(item,index) in shiftList" :key="index" :value="(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId)">{{item.shiftBasic.title}}</option>
                    </select>
                    <!-- 帰り用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.connectSourceShiftId" v-else
                      :name='`connectShift${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="setShiftConnectStationList(1), chooseConnect()">
                      <option v-for="(item,index) in shiftList" :key="index" :value="(item.functionFlag == '1'?item.shiftBasic.shiftId:item.frontId)">{{item.shiftBasic.title}}</option>
                    </select>
                  </div>
                </div>
                <!-- 接続先運行便エラー -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('connectShift' + index)" class="errorMessage"> {{ errors.first('connectShift' + index) }} </span>
                  </div>
                </div>
                <!-- 接続先停留所 -->
                <div class="clearfix divMarginTop">
                  <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                    <div class="row clearfix">
                      <div class="col-md-12 column clearfix">
                        接続先停留所
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 column shortInput">
                    <!-- 行き用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.stationId" v-if="shiftList[0].shiftBasic.shiftFlag == 0"
                      :name='`connectStation${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="chooseConnect()">
                      <option v-for="(station,index) in connect.frontShiftConnect.stationList" :key="index" :value="station.stationId" v-if="station.officeFlag != 1 && station.canArrive != false">{{station.stationName}}</option>
                    </select>
                    <!-- 帰り用 -->
                    <select class="selectstyles selectImg F3-R-20" v-model="connect.frontShiftConnect.connectSourceStationId" v-else
                      :name='`connectStation${index}`'
                      v-validate="'required'"
                      :disabled="lockedByReserve"
                      @change="chooseConnect()">
                      <option v-for="(station,index) in connect.frontShiftConnect.connectSourceStationList" :key="index" :value="station.stationId" v-if="station.officeFlag != 1 && station.canArrive != false">{{station.stationName}}</option>
                    </select>
                  </div>
                  <div class="col-md-4 column divTitle bgc8 connectItemTime">
                    <div class="row clearfix">
                      <div class="column clearfix" :class="{connectTimeError:connect.frontShiftConnect.timeError == 2}">
                        {{getHourMin(shiftList[0].shiftBasic.shiftFlag == 0 ? connect.frontShiftConnect.stationTime:connect.frontShiftConnect.connectSourceStationTime)}}発
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 接続先停留所エラー -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="errors.has('connectStation' + index)" class="errorMessage"> {{ errors.first('connectStation' + index) }} </span>
                  <span v-if="connect.frontShiftConnect.timeError == 2" class="errorMessage"> 停留所あるいは便情報の時刻を修正してください。 </span>
                  </div>
                </div>
                <!-- 接続設定総合エラー -->
                <div class="clearfix">
                  <div class="col-md-2 column shortDiv">
                  </div>
                  <div class="col-md-8 column textAlignLeft">
                  <span v-if="connect.frontShiftConnect.errorMessage != ''" class="errorMessage"> {{ connect.frontShiftConnect.errorMessage }} </span>
                  </div>
                </div>
              </div>
              <!-- 接続削除ボタン -->
              <div class="connectItemRemove">
                <div  @click="delConnect(index)" v-if="index>0 && !lockedByReserve"> － </div>
              </div>
            </div>
          </div>
          <!-- 接続追加ボタン -->
          <div class='bodyContext add' v-if="!lockedByReserve&&!lockedByAddShift">
              <div @click="addConnect">
                <!-- 圆圈 -->
                <div class='addIcon bgc6' style="cursor:pointer">
                  <div style="font-size:2em;color:#fff">+</div>
                </div>
                <!-- 字体 -->
                <div class='addFontSize' style="cursor:pointer">
                  <div><p style="margin:auto 0;letter-spacing:5px;font-weight: 600; color:#707070">接続の追加</p></div>
                </div>
              </div>
          </div>
        </div>
        <!-- 繰り返し登録チェックボックス -->
        <div class="clearfix divMarginTop"  v-if="functionFlag==='0'">
          <div class="repeatCheckBoxBar">
          </div>  
          <div class="col-md-1 column checkBoxDiv paddingLeftZero paddingRightZero" style="width:40px">
            <label class="checkbox-inline">
            <input
              type="checkbox"
              v-model="loopUseCheckbox"
              class="btn btn-default radiobutton"/>
              <span></span>
              </label>
          </div>
          <div class="col-md-5 column aloneWordDiv F3-R-22" style="justify-content:flex-start">
            繰り返し登録を適用
          </div>
        </div>
        <!-- 繰り返し登録項目 -->
        <div class="clearfix bottomDiv bgc5" :class="{floatStyle:(routeSelected&&functionFlag==='0')||(functionFlag!=='0')}" v-show="loopUseCheckbox">
          <div class="col-md-12 column">
            <div class="row clearfix">
              <div class="col-md-12 column T7-longtitle F2-M-19 bgc3" style="text-align: center;">
                繰り返し登録項目
              </div>
            </div>
            <div class="clearfix divMarginTop">
              <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                <div class="row clearfix">
                  <div class="col-md-3 column clearfix">
                    ※
                  </div>
                  <div class="col-md-9 column clearfix paddingLeftZero textAlignLeft">
                    パターン設定
                  </div>
                </div>
              </div>
              <div class="col-md-10 column textAlignLeft">
                <div class="clearfix">
                <div class="col-md-1 column aloneWordDiv F3-R-20" style="justify-content:flex-start;width:65px">
                  毎週
                </div>
                <div class="col-md-1 column checkBoxDiv paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="mondayCheckbox"
                  name="checkbox1"
                  v-validate="{required: loopUseCheckbox&&
                                        !tuesdayCheckbox&&!wednesdayCheckbox&&
                                        !thursdayCheckbox&&!fridayCheckbox&&
                                        !saturdayCheckbox&&!sundayCheckbox}"
                  class="btn btn-default radiobutton"/>
                  <span></span> 月
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="tuesdayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 火
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="wednesdayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 水
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="thursdayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 木
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="fridayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 金
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="saturdayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 土
                </label>
                </div>
                <div class="col-md-1 column checkBoxDiv  paddingLeftZero">
                <label class="checkbox-inline F3-R-20">
                <input
                  type="checkbox"
                  v-model="sundayCheckbox"
                  class="btn btn-default radiobutton"/>
                  <span> </span> 日
                </label>
                </div>
                </div>
              </div>
            </div>
            <div class="clearfix">
              <div class="col-md-2 column shortDiv">
              </div>
              <div class="col-md-10 column errorMessageDiv textAlignLeft">
              <span v-if="errors.has('checkbox1')" class="errorMessage"> {{ errors.first('checkbox1') }} </span>
              </div>
            </div>
            <div class="clearfix divMarginTop">
              <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                <div class="row clearfix">
                  <div class="col-md-3 column clearfix">
                    ※
                  </div>
                  <div class="col-md-9 column clearfix textAlignLeft" style="padding-left:8px">
                    適用開始日
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput" style="width:37%">
                <calendar-input
                @getValue="getStartTime"
                :selectY="startYear"
                :selectM="startMonth"
                :selectD="startDay"
                :need-weeks=true
                :input-style="'height: 50px;font-size: 16px;padding-left:12px;background-color:white'"></calendar-input>
              </div>
              <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                <div class="row clearfix">
                  <div class="col-md-3 column clearfix">
                    ※
                  </div>
                  <div class="col-md-9 column clearfix textAlignLeft" style="padding-left:8px">
                    適用終了日
                  </div>
                </div>
              </div>
              <div class="col-md-4 column shortInput paddingRightZero" style="width:37%">
                <calendar-input
                @getValue="getEndTime"
                :selectY="endYear"
                :selectM="endMonth"
                :selectD="endDay"
                :need-weeks=true
                :input-style="'height: 50px;font-size: 16px;padding-left:12px;background-color:white'"></calendar-input>
              </div>
            </div>
            <div class="clearfix" style="margin-top:5px">
              <div class="col-md-2 column shortDiv divTitle bgc8 F3-R-15">
                <div class="row clearfix">
                  <div class="col-md-3 column clearfix">
                    ※
                  </div>
                  <div class="col-md-9 column clearfix textAlignLeft" style="padding-left:12px">
                    適用間隔
                  </div>
                </div>
              </div>
              <div class="col-md-2 column" style="width:12%">
                  <input
                    type="text"
                    name="interval"
                    v-validate="{required: loopUseCheckbox,numeric:loopUseCheckbox}"
                    v-model="weekIntervalNum"
                    @blur="removeZero(weekIntervalNum)"
                    class="inputstyles F3-R-20"/>
              </div>
              <div class="col-md-1 column aloneWordDiv F3-R-20" style="justify-content:flex-start;">
                週ごと
              </div>
            </div>
            <div class="clearfix">
              <div class="col-md-2 column shortDiv">
              </div>
              <div class="col-md-10 column textAlignLeft">
              <span v-if="errors.has('interval')" class="errorMessage"> {{ errors.first('interval') }} </span>
              </div>
            </div>
            <div class="clearfix divMarginTop">
            </div>
          </div>
        </div>
        <!-- エラー一覧エリア -->
        <div class="errorListArea" id="errorlist-area">
          <div class="errorListBar"></div>
          <div class="errorList">
            <div v-show="shiftErrorList.length > 0">
              <div class="errorListTitle">便情報エラー</div>
              <div>
                <div v-for="(item, index) in shiftErrorList" :key="index">
                  <a @click="scrollToAnchorPoint('shiftItem'+item.index)">便名「{{item.title}}」に間違いがあります。確認してください。</a>
                </div>
              </div>
            </div>
            <div v-show="connectErrorList.length > 0|| notUseShiftList.length > 0 || connectTimeError == true">
              <div class="errorListTitle">乗り継ぎ接続設定エラー</div>
              <div>
                <div v-for="(item, index) in connectErrorList" :key="index">
                  <a @click="scrollToAnchorPoint('connectItem'+(item.index))">乗り継ぎ接続設定{{item.index + 1}}に間違いがあります。確認してください。</a>
                </div>
                <div v-show="connectErrorList.length == 0" v-for="(item, index) in notUseShiftList" :key="index">
                  <p>便名「{{item}}」が接続に使用されていません。確認してください。</p>
                </div>
              </div>
            </div>
          </div>
          <div class="errorListBar"></div>
        </div>
        <v-dialog v-show="showDialog" :dialog-option="dialogOption" ref="dialog"></v-dialog>
      </div>
      <div style="flex: 0 0 100px">
      </div>
    </div>
    <div class="row clearfix" style="margin-top:10px;margin-bottom:30px;display:flex;">
      <div style="flex: 0 0 180px">
      </div>
      <div style="flex:1">
        <div class="clearfix" style="display:flex;justify-content:center" v-if="!isLoading">
          <div class="col-md-4 column textAlignRight"
          :class="{twoButtonWidth:functionFlag==='2'||functionFlag==='3',
          threeButtonWidth:functionFlag==='0'||functionFlag==='1'}">
          <a id="modal-shift-detail-event"  @click="submit(); makeErrorList()"   data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
            <button class="btn btn-default T7-larginbtn window-button F2-M-24" style="width:100%" onkeydown="if(event.keyCode==13 || event.keyCode==32 )return false;">{{btnName}}</button>
          </a>
          </div>
          <div class="col-md-4 column textAlignLeft threeButtonWidth" v-if="functionFlag==='0'||(functionFlag==='1' && this.shiftList[0].shiftBasic.shiftType ==='1')">
            <button class="btn btn-default T7-larginbtn window-button F2-M-24" style="width:100%" @click="eventMake(); makeErrorList()">イベント作成</button>
          </div>
          <div class="col-md-4 column textAlignLeft"
          :class="{twoButtonWidth:functionFlag==='2'||functionFlag==='3',
          threeButtonWidth:functionFlag==='0'||functionFlag==='1'}">
            <button class="btn btn-default T7-larginbtn window-button F2-M-24" style="width:100%" @click="goback">キャンセル</button>
          </div>
        </div>
      </div>
      <div style="flex: 0 0 180px">
      </div>
    </div>

    <!-- <route-info-window ref="routeInfoWindow" :routeId='shiftBasicModel.routeId'></route-info-window> -->
    <route-info-window ref="routeInfoWindow"></route-info-window>
      <!-- :eventInfoModel="shiftEvent" -->
    <shift-detail-event-window-mask
      :shiftList ="shiftList"
      :eventInfoModel="shiftEvent"
      :shiftConnectList ="shiftConnectList"
      :connectGroupList ="connectGroupList"
      :connectGroupHtml ="connectGroupHtml"
      :shiftBasicModel="shiftBasicModel"
      :functionFlag="functionFlag"
      :option ="option"
      ref="shiftInfoDialog">
    </shift-detail-event-window-mask>
  </div>
</template>

<style scoped>
.T7-title {
  margin-top: 25px;
  font-size: 25px;
  color: black;
}
.divTitle {
  height: 50px;
  line-height: 50px;
}
.T7-radius {
  width: 100%;
  max-width: 200px;
  height: 50px;
  background: linear-gradient(#a4a4a2 50%, rgb(138, 138, 138) 50%);
  border-radius: 30px;
  text-align: center;
  padding: 0;
  border: 0;
}
.T7-longtitle {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: left;
}
.T7-larginbtn {
  width: 85%;
}
.inputstyles {
  width: 100%;
  height: 50px;
  line-height: 20px;
  text-align: left;
  border-radius: 0px;
  padding-left: 10px;
  border:1px solid #ccc;
}
.selectstyles {
  border: solid 1px #ccc;
  border-radius: 10px;
  width: 100%;
  height: 50px;
  line-height: 20px;
  text-align: left;
  padding-left: 12px;
  padding-right:30px;
}
.selectImg {
  outline:none;
  float: right;
  text-indent: 1px;
  -moz-appearance:none;
  -webkit-appearance:none;
  background: url("../assets/dropselect.png") no-repeat scroll right center transparent;
}
.radiodiv {
  border-radius: 10px;
  width: 300px;
  height: 45px;
  margin-top: 5px;
  text-align: center;
  font-size: 18px;
}
.radiobutton {
  height: 30px;
  width: 30px;
}
.checkBoxDiv {
  font-size: 18px;
  margin-top: 7px;
  text-align: left;
}
input[type="radio"] + span {
  display: inline-block;
  width: 16px;
  vertical-align: middle;
  margin-top: 40px;
}
input[type="checkbox"] + span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
  margin-top: 40px;
}
.longsolid {
  padding: 0px 12px;
  text-align: left;
}
.textAlignLeft {
  text-align: left;
}
.textAlignRight {
  text-align: right;
}
.paddingLeftZero {
  padding-left: 0px;
}
.paddingRightZero {
  padding-right: 0px;
}
.shortInput {
  width: 35%;
}
.stationWidth {
  width: 48%;
}
.shortDiv {
  width: 13%;
  min-width: 120px;
}
.bottomDiv {
  margin-top: 10px;
  width: 95.2%;
  min-width: 816px;
}
.divMarginTop {
  margin-top: 10px;
}
.errorMessageDiv {
  margin-top: -10px;
  margin-bottom: 10px;
}
.errorMessage {
  color: red;
}
.hourMinute {
  width:5%;
}
.aloneWordDiv{
  display:flex;
  align-items:center;
  justify-content:center;
  height:50px;
  padding-left: 0px;
  padding-right: 0px;
}
.twoButtonWidth{
  width: 45%;
}
.threeButtonWidth{
  width: 30%;
}
.floatStyle{
  position: relative;
  top:-90px;
}
.belowLeftWidth{
  width:22.23%;
}
.belowRightWidth{
  width:60%;
}

</style>

<style lang="scss">
.add {
    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
        // border: 1px solid blue;
        width: 400px;
        height: 50px;
        display: flex;
        flex-direction: row;
        & > .addIcon {
          background-color: #c7c8c8;
            margin: 5px 5px 5px auto;
            width: 40px;
            // border: 1px solid blue;
            border-radius: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        & > .addFontSize {
            margin-left: 10px;
            margin-right: auto;
            display: flex;
            justify-content: center;
            align-items: center;
            // border: 1px solid blue;
            & > div {
              // border: 1px solid blue;
              font-size: 1.5em
            }
        }
    }
}
.shiftItem{
  // display: flex;
  margin-top: 16px;
  padding: 2px;
  // background-color: #bbffcc;

  .shiftItemBar{
    width:100%;
    height:4px;
    background-color:#bbb;
  }

  .shiftItemFlex{
    display: flex;
    margin-top: 10px;

    > input{
        display: none;
    }
    > input[type="checkbox"]:checked ~ .shiftItemMain{
      min-height: 124px;
    }
    .shiftItemMain > div{
      opacity: 1;
      transition: 0.5s;
    }
    > input[type="checkbox"]:checked ~ .shiftItemMain > div:not(.shiftViewHead){
      display: none;
      opacity: 0;
    }
    // > input[type="checkbox"]:checked + .shiftItemMain > div:nth-child(1){
    //   display: none;
    // }

    > input[type="checkbox"]:checked ~ .shiftItemMain + .shiftItemRemove{
      // display: none;
      opacity: 1;
      color: transparent;
      pointer-events: none;
    }
  }

  .shiftItemMain{
    min-height: 500px;
    transition: 0.5s;
  }

  .shiftItemView{
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #666;
    text-align: center;
    line-height: 40px;
    transform:rotate(0deg);
    user-select: none;
    transition: 0.2s;
  }
  input[type="checkbox"]:checked ~ label > .shiftItemView{
    transform:rotate(-90deg);
  }
  .shiftItemRemove{
    width: 40px;
    height: 40px;
    font-size: 24px;
    color: #666;
    text-align: center;
    line-height: 40px;
  }
  .shiftItemMain{
    width: 100%;
  }
}
.shiftAddArea{
  .shiftAddBar{
    width:100%;
    height:4px;
    background-color:#bbb;
  }

  .add{
    margin-top: 10px;
  }
}
.connectItem{
  // display: flex;
  margin-top: 12px;
  padding: 2px;
  // background-color: #bbffff;

  .connectItemBar{
    width:100%;
    height:4px;
    background-color:#bbb;
  }

  .connectItemFlex{
    display: flex;
    padding: 0 10px
  }
  .connectItemMain{
    width: 100%;
  }

  .connectItemTitle{
    margin: 10px 0 0 10px;
    text-align: left;
    font-size: 16px;
  }
  .connectItemRemove{
    width: 40px;

    > div{
      width: 40px;
      height: 40px;
      font-size: 24px;
      color: #666;
      text-align: center;
      line-height: 40px;
    }
  }

  .connectTimeError{
    color: red;
  }

  .connectSelectLong{
    width: 70%;
  }

  .connectItemTime{
    width: 140px;
    font-size: 20px;
  }
}

.repeatCheckBoxBar{
  width:100%;
  height:4px;
  background-color:#bbb;
}

.errorListArea{
  margin-top: 30px;
  padding-bottom: 30px;

  .errorListBar{
    width:100%;
    height:4px;
    background-color:#bbb;
  }
  .errorList{
    text-align: left;
    margin-bottom: 60px;

    a, p{
      color: red;
      margin-left: 38px;
      font-size: 16px;
      line-height: 28px;
    }
  }
  .errorListTitle{
    font-size: 16px;
    margin: 8px 0 0 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShiftInfoComponent.vue